import React, { useState, useEffect, useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { Form, FormControl } from "react-bootstrap";
import { useCallback } from "react";
import OrderWebSocket from "../../WebSocket/OrderWebSocket";
import { toast, ToastContainer } from "react-toastify";
// import SuccessTick from "../../images/SuccessTick.svg";
import { Link } from "react-router-dom";
import { Button, Modal, Spinner } from "react-bootstrap";
import NoIndex from "../../NoIndex";
// import OrderList from "./OpenOrder";
import down from "../../../images/Down 2.svg";
import Pagination from "../../Whatsapp/Pagination";
import Swal from "sweetalert2";
import jsPDF from "jspdf";
import "jspdf-autotable";
import html2canvas from "html2canvas";
import axios from "axios";
import "../AdminDashboard.css"
import MyContext from "../../../MyContext"; //using ContextAPI to store data dynamically

const Orders = ({ newOrderFlag, Admin, newOrderFlagUpdate }) => {
  const [userID, setuserID] = useState('');
  const [SelectedClient, setSelectedClient] = useState('')
  const [Clients, setClients] = useState([]);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const getOneWeekBackDate = () => {
    const oneWeekBack = new Date();
    oneWeekBack.setDate(oneWeekBack.getDate() - 7);
    const year = oneWeekBack.getFullYear();
    const month = String(oneWeekBack.getMonth() + 1).padStart(2, "0");
    const day = String(oneWeekBack.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const getOneDayBackDate = () => {
    const oneDayBack = new Date();
    oneDayBack.setDate(oneDayBack.getDate() - 1); // Subtract 1 day
    const year = oneDayBack.getFullYear();
    const month = String(oneDayBack.getMonth() + 1).padStart(2, "0");
    const day = String(oneDayBack.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const [startDateCurrent, setStartDateCurrent] = useState(getOneDayBackDate());
  const [endDateCurrent, setEndDateCurrent] = useState(getCurrentDate());
  useEffect(() => {
    // Set initial date range when component mounts


    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        setLatitude(position.coords.latitude);
        setLongitude(position.coords.longitude);
      });
    } else {
      toast.error("Geolocation is not supported by your browser");
    }
  }, [startDateCurrent, endDateCurrent]);
  const FetchClientCall = async () => {
    setLoading(true);
    try {

      const UserDetail = {
        // userid: User.pkid,
        userid: Admin.pkid,
        latitude: latitude,
        longitude: longitude,
      };

      const response = await axios.post(
        `${baseUrl}/api/Admin/getAllClientList`,
        UserDetail,
        config
      );
      if (response.data.responseCode === "00") {
        // toast.success(response.data.responseMessage);

        setClients(response.data.response);

        setLoading(false);
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("error");
      console.error("Error updating Admin login:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    FetchClientCall()
  }, [])


  // ################### Admin Code Ends Here #######################################
  const navigate = useNavigate();
  const previousOrderStatuses = useRef({});
  const { baseUrl } = useContext(MyContext);
  const { config } = useContext(MyContext);
  const [loading, setLoading] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);
  const [orders, setOrders] = useState([]);
  const [runningOrder, setRunningOrder] = useState([]);
  const [orderHistory, setOrderHistory] = useState([]);
  const [openRowIndex_Active, setOpenRowIndex_Active] = useState(null);
  const [openRowIndex_NewOrder, setOpenRowIndex_NewOrder] = useState(null);
  const [openRowIndex_History, setOpenRowIndex_History] = useState(null);
  const [addresses, setAddresses] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const contentRefsCol5 = useRef([]);
  const contentRefsCol1 = useRef([]);
  const [activeTab, setActiveTab] = useState("home-tab");
  const [countNewOrder, setCountNewOrder] = useState("0");
  const [countActiveOrder, setCountActiveOrder] = useState("0");
  const [countOrderHistory, setCountOrderHistory] = useState("0");
  const [statusDriver, setStatusDriver] = useState("");
  const [currentCatalogueStatus, setCurrentCatalogueStatus] = useState("");
  const [isFoodReadyLoading, setIsFoodReadyLoading] = useState(false);
  const [selectedPartnerType, setSelectedPartnerType] = useState("packky"); // Default to "restaurant" partner type
  const [showDoorDashConfirmation, setShowDoorDashConfirmation] =
    useState(false);
  // for modal and loading
  const [isDeliveryModalOpen, setIsDeliveryModalOpen] = useState(false);
  const [isLoadingDeliveryDetails, setIsLoadingDeliveryDetails] =
    useState(false);
  const [deliveryInfo, setDeliveryInfo] = useState(null);
  const [deliveryError, setDeliveryError] = useState(null);
  const [currentOrderId, setCurrentOrderId] = useState("");
  const [deliveryPersonDetails, setDeliveryPersonDetails] = useState({
    name: "",
    mobile: "",
  });
  const [deliveryPersonName, setDeliveryPersonName] = useState("");
  const [deliveryPersonMobile, setDeliveryPersonMobile] = useState("");

  const [startDate, setStartDate] = useState(getOneDayBackDate());
  const [endDate, setEndDate] = useState(getCurrentDate());

  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [orderFilter, setOrderFilter] = useState("newplusactive");
  const [orderAfterFilter, setOrderAfterFilter] = useState([]);
  const [deliveryPartnerList, setDeliveryPartnerList] = useState([]);
  const [selectedDeliveryPartner, setSelectedDeliveryPartner] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const [fullAddressState, setFullAddressState] = useState("");
  const [printConfig, setPrintConfig] = useState({
    normalFontSize: "",
    largeFontSize: "",
    pageWidth: ""
  });


  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 100; // Set how many items per page you want

  // Calculate total pages
  const totalPages = Math.ceil(orderAfterFilter.length / itemsPerPage);

  // Slice the data based on pagination
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const orderAfterFilterPagination = orderAfterFilter.slice(
    startIndex,
    endIndex
  );

  // Handlers for pagination
  const handlePageClick = (pageNumber) => {
    if (
      pageNumber !== currentPage &&
      pageNumber >= 1 &&
      pageNumber <= totalPages
    ) {
      setCurrentPage(pageNumber);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  // Pagination for order history
  const [currentPage_History, setCurrentPage_History] = useState(1);
  const itemsPerPage_History = 20; // Set how many items per page you want for history
  // Calculate total pages for Order History
  const totalPages_History = Math.ceil(
    filteredData.length / itemsPerPage_History
  );
  const startIndex_History = (currentPage_History - 1) * itemsPerPage_History;
  const endIndex_History = startIndex_History + itemsPerPage_History;
  const orderHistoryPagination = filteredData.slice(
    startIndex_History,
    endIndex_History
  );
  // Handlers for Order History pagination
  const handlePageClick_History = (pageNumber) => {
    if (
      pageNumber !== currentPage_History &&
      pageNumber >= 1 &&
      pageNumber <= totalPages_History
    ) {
      setCurrentPage_History(pageNumber);
    }
  };
  const handleNextPage_History = () => {
    if (currentPage_History < totalPages_History) {
      setCurrentPage_History(currentPage_History + 1);
    }
  };
  const handlePrevPage_History = () => {
    if (currentPage_History > 1) {
      setCurrentPage_History(currentPage_History - 1);
    }
  };
  const [particularOrderDetails, setParticularOrderDetails] = useState({});
  const [orderDetailesLoader, setOrderDetailsLoader] = useState(false);
  const toggleRow_NewOrder = async (index, orderid) => {
    setOrderDetailsLoader(true);
    setOpenRowIndex_NewOrder((prevIndex) =>
      prevIndex === index ? null : index
    );
    setAddress("");
    await orderDetailesAPI(orderid);
  };


  const toggleRow_History = async (index, orderid) => {
    setOrderDetailsLoader(true);
    setOpenRowIndex_History((prevIndex) =>
      prevIndex === index ? null : index
    );
    setAddress("");
    await orderDetailesAPI(orderid);
  };

  const [newOrderLoader, setNewOrderLoader] = useState(false);
  const [completeOrderLoader, setCompleteOrderLoader] = useState(false);


  const getNewOrder = async () => {

    try {
      setNewOrderLoader(true);
      const requestBody = {
        adminId: Admin.pkid,
        userid: userID || "",
        statuses: [
          "received",
          "paid",
          "accepted",
          "prepared",
          "rejected",
          "refunded",
          "driver_assigned",
          "driver_confirmed",
          "driver_pickup_arrival",
          "delivery_picked",
          "driver_dropoff_arrival",
        ],
        fromdate: startDateCurrent,
        todate: endDateCurrent,
        latitude,
        longitude,
      };
      const response = await axios.post(
        `${baseUrl}/api/Admin/getAllClientsCatalogueOrders`,
        requestBody,
        config
      );
      if (response.data.responseCode === "00") {
        // detectAndPrintPaidOrders(response.data.response);
        setOrders(response.data.response);
        setCountNewOrder(response.data.response.length);
        setOrderAfterFilter(response.data.response);
        // console.log(runningOrder);
      } else {
        setOrders([]);
        setCountNewOrder("0");
        // console.error("Failed to fetch orders:", response.data.responseMessage);
      }
    } catch (error) {
      // console.error("Error fetching data:", error);
    } finally {
      setNewOrderLoader(false);

      if (firstLoad) {
        setLoading(false);
        setFirstLoad(false);
      }
    }
  };



  const orderDetailesAPI = async (orderid) => {
    try {
      // setOrderDetailsLoader(true);
      const requestBody = {
        orderid: orderid,
      };
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getOrderDetails`,
        requestBody,
        config
      );
      if (response.data && response.data.responseCode === "00") {
        setParticularOrderDetails(response.data.response);

      } else {
        setParticularOrderDetails({});
        setOrderDetailsLoader(false);

      }
    } catch (error) {

      console.error("Error making API call:", error);
    } finally {
      setOrderDetailsLoader(false);
    }
  };

  const orderDetailesAPIForPrint = async (index, orderid, reciptDetails, fullAddress) => {
    try {
      setOrderDetailsLoader(true);

      // ✅ DON'T await this!
      Swal.fire({
        title: "Preparing Print...",
        text: "Fetching order details. Please wait.",
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const requestBody = {
        orderid: orderid,
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getOrderDetails`,
        requestBody,
        config
      );

      if (response.data && response.data.responseCode === "00") {
        const details = response.data.response;

        Swal.close(); // ✅ this will now work correctly
        handlePrint(reciptDetails, details, fullAddress);
      } else {
        Swal.close();
        setParticularOrderDetails({});
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: "Could not fetch order details. Please try again.",
        });
      }
    } catch (error) {
      console.error("Error making API call:", error);
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while fetching order details.",
      });
    } finally {
      setOrderDetailsLoader(false);
    }
  };






  const detectAndPrintPaidOrders = (newOrders) => {
    const previousOrders = JSON.parse(localStorage.getItem("previousOrders")) || {};

    newOrders.forEach((item) => {
      const prevOrder = previousOrders[item.id];
      const wasPreviouslyUnpaid = !prevOrder || prevOrder.status !== "paid";
      const isNowPaid = item.status === "paid";

      if (isNowPaid && wasPreviouslyUnpaid) {
        const addressObj = JSON.parse(item.address_json)?.values || {};
        const fullAddress = [
          addressObj.address,
          addressObj.landmark_area,
          addressObj.building_name,
          addressObj.house_number,
          addressObj.floor_number,
          addressObj.city,
          addressObj.state,
          addressObj.in_pin_code,
        ]
          .filter(Boolean)
          .join(", ");

        // ✅ Call the print function
        handlePrintNode(
          item,
          reciptDetails.business_name,
          reciptDetails.gst,
          reciptDetails.address,
          reciptDetails.phone_no,
          fullAddress,
          printConfig.normalFontSize,
          printConfig.largeFontSize,
          printConfig.pageWidth
        )
      }
    });

    // ✅ Save current orders as the new "previousOrders"
    const ordersMap = {};
    newOrders.forEach((o) => {
      ordersMap[o.id] = { status: o.status };
    });
    localStorage.setItem("previousOrders", JSON.stringify(ordersMap));
  };

  const calculateElapsedTime = (orderDate) => {
    // Define a format matching the new API date format
    const [datePart, timePart, period] = orderDate.split(" ");
    const [day, month, year] = datePart.split("/").map(Number);
    let [hours, minutes, seconds] = timePart.split(":").map(Number);
    // Adjust hours for AM/PM
    if (period === "PM" && hours !== 12) {
      hours += 12;
    } else if (period === "AM" && hours === 12) {
      hours = 0; // Handle 12 AM case
    }
    // Create a new date object using the parsed values
    const orderTime = new Date(
      year,
      month - 1,
      day,
      hours,
      minutes,
      seconds
    ).getTime();
    const now = new Date().getTime();
    const difference = now - orderTime;
    const totalMinutes = Math.floor(difference / (1000 * 60)); // Total minutes
    const totalHours = Math.floor(totalMinutes / 60); // Total hours
    if (totalHours > 0) {
      return {
        time: `${totalHours} ${totalHours === 1 ? "hour" : "hours"}`,
        status: "overdue",
      };
    } else {
      return {
        time: `${totalMinutes} min`,
        status: "normal",
      };
    }
  };
  const OrderHistoryAPI = async () => {
    const currentDate = startDate;
    const oneWeekBackDate = endDate;
    try {
      setCompleteOrderLoader(true);
      // if (firstLoad) setLoading(true);

      const responseBody = {
        adminId: Admin.pkid,
        userid: userID || "",
        statuses: [
          "completed",
          "dispatched",
          "delivered",
          "ready_for_dinning",
          "ready_for_takeway",
          "not-delivered",
          "driver_assigned",
          "driver_confirmed",
          "driver_pickup_arrival",
          "delivery_picked",
          "driver_dropoff_arrival",
        ],
        fromdate: startDate,
        todate: endDate,
        latitude,
      };
      const response = await axios.post(
        `${baseUrl}/api/Admin/getAllClientsCatalogueOrders`,
        responseBody,
        config
      );
      if (response.data.responseCode === "00") {
        setOrderHistory(response.data.response);
        setCountOrderHistory(response.data.response.length);
        setFilteredData(response.data.response);
        // console.log(response.data.response);
      } else if (response.data.responseCode === "01") {
        setOrderHistory([]); // Clear order history
        setCountOrderHistory(0);
        setFilteredData([]);
      } else {
        // console.error("Failed to fetch orders:", response.data.responseMessage);
      }
    } catch (error) {
      // console.error("Error fetching data:", error);
    } finally {
      setCompleteOrderLoader(false);
      if (firstLoad) {
        setLoading(false);
        setFirstLoad(false);
      }
    }
  };
  useEffect(() => {
    getNewOrder();
    OrderHistoryAPI();
    // const intervalId = setInterval(() => {
    //   getNewOrder();
    //   OrderHistoryAPI();
    // }, 10000);
    // return () => clearInterval(intervalId);

  }, [
    startDate,
    endDate,
    startDateCurrent,
    endDateCurrent,
    newOrderFlag,
    newOrderFlagUpdate,
    userID
  ]);

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
  };
  const thTdStyle = {
    // padding: "10px",
    // borderBottom: "1px solid #ddd",
    height: "5rem",
  };
  const thTdStyleAction = {
    padding: "10px",
    borderBottom: "0px solid #ddd",
  };
  const accordionToggleStyle = {
    cursor: "pointer",
    transition: "background-color 0.3s ease",
  };
  const accordionContentStyle = {
    height: "0",
    overflow: "hidden",
    transition: "height 0.3s ease",
    backgroundColor: "#f9f9f9",
  };

  const openRowStyle = {
    backgroundColor: "#f9f9f9",
    color: "#000",
    // boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
  };

  const openButtonStyle1 = {
    color: "red",
    backgroundColor: "white",
  };

  const [address, setAddress] = useState("");

  const getAddressFromCoordinates = async (lat, lon) => {
    try {
      const response = await axios.get(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}&zoom=18&addressdetails=1`
      );
      if (response.data && response.data.address) {
        const { road, suburb, city, state, country } = response.data.address;
        const readableAddress = `${road ? road + ", " : ""}${suburb ? suburb + ", " : ""
          }${city ? city + ", " : ""}${state ? state + ", " : ""}${country ? country : ""
          }`;
        setAddress(readableAddress);
      } else {
        // setError('No address found for the provided coordinates.');
      }
    } catch (err) {
      // setError('An error occurred while fetching the address.');
      // console.error(err);
    }
  };
  const paymentMessageAPI = async (
    userid,
    orderId,
    customer_name,
    customer_mobile
  ) => {
    try {
      const requestBody = {
        userid: SelectedClient,
        orderId: orderId,
        custName: customer_name,
        custMobile: customer_mobile,
      };
      const response = await axios.post(
        `${baseUrl}/api/Order/generatePaymentIntent`,
        requestBody,
        config
      );
      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);
      } else {
        toast.error(response.data.responseMessage || "An error occurred");
      }
    } catch {
      toast.error("An error occurred");
    }
  };
  const acceptOrderApi = async (orderId, ClientID, customer_mobile) => {
    Swal.fire({
      title: "Payment Completed ?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Completed!",
    }).then((result) => {
      if (result.isConfirmed) {
        // User confirmed, proceed with the API request
        try {
          const requestBody = {
            userid: ClientID,
            orderid: orderId,
            productid: "",
            status: "paid_completed",
            time: "",
            payment: "",
          };
          axios
            .post(
              `${baseUrl}/api/Whatsapp/changeCatelogOrderStatus`,
              requestBody,
              config
            )
            .then((response) => {

              setCountActiveOrder("0");
              setRunningOrder([]);
              getNewOrder();
              toast.success("This order has been accepted successfully.");
              // paymentMessageAPI(
              //   userID,
              //   orderId,
              //   customer_name,
              //   customer_mobile
              // );
            })
            .catch((error) => {
              // Handle error here
              // console.error("Error during the API request:", error);
              Swal.fire(
                "Error!",
                "Something went wrong with accepting the order.",
                "error"
              );
            });
        } catch (error) {
          console.error("Catch block error:", error);
          Swal.fire("Error!", "Something went wrong.", "error");
        }
      }
    });
  };
  const rejectOrderAPI = async (orderId, clientID) => {
    Swal.fire({
      title:
        '<strong style="font-size: 24px; color: #333;">Cancel Order</strong>',
      html: `
        <p style="font-size: 16px; color: #555; margin-top: 10px;">
          Are you sure you want to cancel this order? This action cannot be undone.
        </p>
        <select id="cancelReason" class="swal2-select" style="
          padding: 10px;
          margin-top: 15px;
          border-radius: 8px;
          font-size: 16px;
          border: 1px solid #ddd;
        ">
          <option value="" disabled selected>Select reason for cancellation</option>
           <option value="Menu Item Out of Stock">Menu Item Out of Stock</option>
              <option value="Delivery Address is Out of Range">Delivery Address is Out of Range</option>
  <option value="Delivery Delayed Due to Bad Weather"> Due to Bad Weather</option>
            <option value="Customer Request Exceeds Delivery Radius">Customer Request Exceeds Delivery Radius</option>
        </select>
      `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Cancel Order!",
      cancelButtonText: "No",
      focusConfirm: false,
      customClass: {
        confirmButton: "swal2-confirm-btn", // Adding custom classes for better styling
        cancelButton: "swal2-cancel-btn",
        popup: "swal2-custom-popup",
      },
      preConfirm: () => {
        const reason = document.getElementById("cancelReason").value;
        if (!reason) {
          Swal.showValidationMessage("Please select a reason for cancellation");
          return false;
        }
        return reason; // Pass the reason to the `then` block
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const selectedReason = result.value; // Get the selected reason

        // Proceed with the API request
        try {
          const requestBody = {
            userid: clientID,
            orderid: orderId,
            productid: "",
            status: "rejected",
            time: "",
            payment: "",
            remark: selectedReason, // Pass the selected reason in the request
          };

          axios
            .post(
              `${baseUrl}/api/Whatsapp/changeCatelogOrderStatus`,
              requestBody,
              config
            )
            .then((response) => {
              // Handle success
              // console.log(response);
              getNewOrder();
              // RunningOrder();
              Swal.fire(
                "Cancelled!",
                "This order has been cancelled.",
                "success"
              );
            })
            .catch((error) => {
              // Handle error here
              // console.error("Error during the API request:", error);
              Swal.fire(
                "Error!",
                "Something went wrong with cancelling the order.",
                "error"
              );
            });
        } catch (error) {
          // console.error("Catch block error:", error);
          Swal.fire("Error!", "Something went wrong.", "error");
        }
      }
    });
  };

  useEffect(() => {
    axios
      .post(`${baseUrl}/api/User/getDeliveryPersons`, {
        userid: userID,
      },config)
      .then((response) => {
        if (response.data.responseCode === "00") {
          setDeliveryPartnerList(response.data.response);
        } else {
          // toast.error("Failed to fetch delivery persons");
        }
      })
      .catch((error) => {
        // console.error("Error fetching delivery persons:", error);
        // toast.error("Error fetching delivery persons");
      });
  }, []);

  const handleDeliveryPartnerSelection = (partner) => {
    setSelectedDeliveryPartner(partner.id);
    setDeliveryPersonName(partner.contact_name); // Set the name
    setDeliveryPersonMobile(partner.contact_number); // Set the mobile number
  };

  const assignDeliveryPartner = async (
    modelData,
    selectedDeliveryPartner,
    fullAddressState
  ) => {
    try {
      const requestBody = {
        userid: userID,
        orderid: modelData.orderid,
        deliveryPersonId: selectedDeliveryPartner,
      };

      const response = await axios.post(
        `${baseUrl}/api/Order/assignDeliveryPerson`,
        requestBody,
        config
      );
      if (response.data.responseCode === "00") {
        if (
          !modelData.delivery_person_name ||
          !modelData.delivery_person_number
        ) {
          modelData.delivery_person_name = deliveryPersonName || "";
          modelData.delivery_person_number = deliveryPersonMobile || "";
        }
        completeOrderApi(modelData, modelData.orderid, fullAddressState);
        toast.success(response.data.responseMessage);
        setShowModal(false);
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch {
      toast.error("");
    }
  };

  const sendOrderReciptApi = async (item, orderId, fullAddress) => {
    try {
      // Generate PDF and get Base64 string
      const imageData = await generatePNG(
        item,
        fullAddress,
        organizationDetails,
        reciptDetails
      );

      // Request body for sending receipt
      const requestBodySendImage = {
        userid: userID,
        secret: "string",
        order_id: orderId,
        image_data: imageData,
        type: "IMG",
      };
      // Sending receipt
      await axios.post(
        `${baseUrl}/api/Whatsapp/sendReceipt`,
        requestBodySendImage,
        config
      );
      await Promise.all([getNewOrder(), OrderHistoryAPI()]);
      // toast.success("Order Dispatched Successfully");
      getNewOrder();
      OrderHistoryAPI();
    } catch (error) {
      // Handle error here
      // console.error("Error during the API request:", error);
    }
  };

  const completeOrderApi = async (item, orderId, fullAddress) => {
    try {
      // Generate PDF and get Base64 string
      const imageData = await generatePNG(
        item,
        fullAddress,
        organizationDetails,
        reciptDetails
      );

      // Request body for order completion
      const requestBody = {
        userid: userID,
        orderid: orderId,
        productid: "",
        status: "dispatched",
        time: "",
        payment: "",
      };
      // Sending order completion
      await axios.post(
        `${baseUrl}/api/Whatsapp/changeCatelogOrderStatus`,
        requestBody,
        config
      );
      // Request body for sending receipt
      const requestBodySendImage = {
        userid: userID,
        secret: "string",
        order_id: orderId,
        image_data: imageData,
        type: "IMG",
      };
      // Sending receipt
      await axios.post(
        `${baseUrl}/api/Whatsapp/sendReceipt`,
        requestBodySendImage,
        config
      );
      // Handle success
      // console.log("Order completed and receipt sent.");
      setCountActiveOrder("0");
      await Promise.all([getNewOrder(), OrderHistoryAPI()]); // Ensure both calls complete
      toast.success("Order Dispatched Successfully");
      setModalData({});
      setFullAddressState("");
      getNewOrder();
      OrderHistoryAPI();
    } catch (error) {
      // Handle error here
      // console.error("Error during the API request:", error);
      Swal.fire(
        "Error!",
        "Something went wrong with completing the order.",
        "error"
      );
    }
  };

  const diningOrderApi = async (modelData) => {
    try {
      // Request body for order completion
      const requestBody = {
        userid: userID,
        orderid: modelData.orderid,
        productid: "",
        status: "ready_for_dinning",
        time: "",
        payment: "",
      };
      // Sending order completion
      await axios.post(
        `${baseUrl}/api/Whatsapp/changeCatelogOrderStatus`,
        requestBody,
        config
      );
      setCountActiveOrder("0");
      await Promise.all([getNewOrder(), OrderHistoryAPI()]); // Ensure both calls complete
      toast.success("Order Dispatched Successfully");
      setModalData({});
      setFullAddressState("");
      getNewOrder();
      OrderHistoryAPI();
    } catch (error) {
      // Handle error here
      // console.error("Error during the API request:", error);
      Swal.fire(
        "Error!",
        "Something went wrong with completing the order.",
        "error"
      );
    }
  };
  const TakeWayOrderApi = async (modelData, orderID, fullAddress) => {
    try {
      // Request body for order completion
      const requestBody = {
        userid: userID,
        orderid: modelData.orderid,
        productid: "",
        status: "ready_for_takeway",
        time: "",
        payment: "",
      };
      // Sending order completion
      await axios.post(
        `${baseUrl}/api/Whatsapp/changeCatelogOrderStatus`,
        requestBody,
        config
      );
      setCountActiveOrder("0");
      await Promise.all([getNewOrder(), OrderHistoryAPI()]); // Ensure both calls complete
      toast.success("Order Dispatched Successfully");
      setModalData({});
      setFullAddressState("");
      getNewOrder();
      OrderHistoryAPI();
      // Call heavy API only after successful status update
      try {
        await sendOrderReciptApi(modelData, orderID, fullAddress);
      } catch (receiptError) {
        // console.error("Error sending order receipt:", receiptError);
        toast.error("Failed to send order receipt.");
      }
    } catch (error) {
      // Handle error here
      console.error("Error during the API request:", error);
      Swal.fire(
        "Error!",
        "Something went wrong with completing the order.",
        "error"
      );
    }
  };
  const markCompletedForcefullyApi = async (orderID) => {
    // Open Swal confirmation dialog
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to mark this order as delivered?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, mark it as delivered!",
      cancelButtonText: "No, cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // Request body for order completion
          const requestBody = {
            userid: userID,
            orderid: orderID,
            productid: "",
            status: "delivered",
            time: "",
            payment: "",
          };

          // Sending order completion
          await axios.post(
            `${baseUrl}/api/Whatsapp/changeCatelogOrderStatus`,
            requestBody,
            config
          );
          setCountActiveOrder("0");
          await Promise.all([getNewOrder(), OrderHistoryAPI()]);
          toast.success("Order Delivered Successfully");
          setModalData({});
          setFullAddressState("");
          getNewOrder();
          OrderHistoryAPI();
        } catch (error) {
          // Handle error here
          console.error("Error during the API request:", error);
          Swal.fire(
            "Error!",
            "Something went wrong with completing the order.",
            "error"
          );
        }
      } else {
        // If user cancels
        Swal.fire(
          "Cancelled",
          "The order has not been marked as delivered.",
          "info"
        );
      }
    });
  };

  const handleSearch = useCallback(() => {
    const afterFilter = orderHistory.filter((item) => {
      const itemString = Object.values(item)
        .map((value) => (typeof value === "string" ? value.toLowerCase() : ""))
        .join("");

      return itemString.includes(searchQuery.toLowerCase());
    });

    setFilteredData(afterFilter);
  }, [orderHistory, searchQuery]);

  useEffect(() => {
    handleSearch();
  }, [handleSearch]);



  const [searchTableNumber, setSearchTableNumber] = useState("");

  const orderFilterFunction = () => {
    if (orderFilter === "newplusactive") {
      const afterFilterData = orders.filter((item) =>
        ["received", "paid", "accepted", "prepared"].includes(item.status)
      );
      setSearchTableNumber("");
      setOrderAfterFilter(afterFilterData);
    } else if (orderFilter === "tableSearch" && searchTableNumber) {
      const afterFilterData = orders.filter(
        (item) =>
          item.table_no && item.table_no.toString().includes(searchTableNumber)
      );
      setOrderAfterFilter(afterFilterData);
    } else if (orderFilter === "tableSearch" && !searchTableNumber) {
      setOrderFilter("newplusactive");
      const afterFilterData = orders.filter((item) =>
        ["received", "paid", "accepted", "prepared"].includes(item.status)
      );
      setSearchTableNumber("");
      setOrderAfterFilter(afterFilterData);
    } else if (orderFilter === "dining") {
      const afterFilterData = orders.filter(
        (item) => item.orderType === "dining"
      );
      setSearchTableNumber("");
      setOrderAfterFilter(afterFilterData);
    } else if (orderFilter === "new") {
      const afterFilterData = orders.filter(
        (item) => item.status === "received"
      );
      setSearchTableNumber("");
      setOrderAfterFilter(afterFilterData);
    } else if (orderFilter === "rejected" || orderFilter === "refunded") {
      const afterFilterData = orders.filter(
        (item) => item.status === "rejected" || item.status === "refunded"
      );
      setSearchTableNumber("");
      setOrderAfterFilter(afterFilterData);
    } else {
      const afterFilterData = orders.filter(
        (item) => item.status === "paid" || item.status === "accepted"
      );
      setSearchTableNumber("");
      setOrderAfterFilter(afterFilterData);
    }
  };
  useEffect(() => {
    orderFilterFunction();
  }, [orderFilter, orders, searchTableNumber]);
  //Get Business Information
  const [organizationDetails, setOrganizationDetails] = useState("");
  const [reciptDetails, setreciptDetails] = useState({});

  const reciptDetailsApi = async () => {
    try {
      const response = await axios.post(`${baseUrl}/api/Order/getReceiptData`, {
        userid: userID,
      });

      if (response.data.responseCode === "00") {
        const receipt = response.data.response[0];
        setOrganizationDetails(response.data.response.logo);
        setreciptDetails(receipt);

        // ✅ Parse and store font sizes and page width
        const parsedPrintSettings = JSON.parse(receipt.printSettings || "[]");

        const normalFontSize = parsedPrintSettings.find(s => s.key === "normalFontSize")?.value || "";
        const largeFontSize = parsedPrintSettings.find(s => s.key === "largeFontSize")?.value || "";
        const pageWidth = parsedPrintSettings.find(s => s.key === "pageWidth")?.value || "";

        setPrintConfig({
          normalFontSize,
          largeFontSize,
          pageWidth
        });
      } else {
        console.error("Failed to fetch organization details");
      }
    } catch (error) {
      console.error("Error fetching organization details:", error);
    }
  };
  useEffect(() => {
    reciptDetailsApi();
    // fetchOrganizationDetails();
  }, []);
  const catalogueStatusApi = async () => {
    try {
      const requestBody = {
        userid: userID,
      };
      const response = await axios.post(
        `${baseUrl}/api/Whatsapp/getCatalogueStatus`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        setCurrentCatalogueStatus(response.data.response.catalogueStatus);
      } else {
      }
    } catch { }
  };
  const catalogueONOFFApi = async (command) => {
    try {
      setCurrentCatalogueStatus(command);

      const requestBody = {
        userid: userID,
        secret: "string",
        status: command,
      };
      const response = await axios.post(
        `${baseUrl}/api/Whatsapp/changeCatalogueStatus`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        Swal.fire({
          title: "Success",
          text: response.data.responseMessage,
          icon: "success",
          confirmButtonText: "Okay",
        });
        catalogueStatusApi();
      } else {
        Swal.fire({
          title: "Error",
          text: "Something went wrong.",
          icon: "error",
          confirmButtonText: "Okay",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "An error occurred while processing your request.",
        icon: "error",
        confirmButtonText: "Okay",
      });
    }
  };
  const handleToggle = () => {
    if (currentCatalogueStatus === "hide") {
      catalogueONOFFApi("show");
    } else {
      catalogueONOFFApi("hide");
    }
  };
  useEffect(() => {
    catalogueStatusApi();
  }, []);
  // Main Print function

  const handlePrintNode = async (
    item,
    business_name,
    gst,
    address,
    phone_no,
    custfullAddress,
    normalFontSize,
    largeFontSize,
    pageWidth
  ) => {
    try {
      console.log("Sending order details:", JSON.stringify(item, null, 2));

      const cleanCustomerAddress = custfullAddress
        .replace(/\s*\n\s*/g, ', ')
        .replace(/,\s*,+/g, ', ')
        .replace(/\s{2,}/g, ' ')
        .trim();

      const response = await fetch("http://localhost:3001/printReceipt", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          item,
          business_name,
          gst,
          address,
          phone_no,
          cleanCustomerAddress,
          printSettings: {
            normalFontSize,
            largeFontSize,
            pageWidth
          }
        }),
      });

      const data = await response.json();

      if (response.ok) {
        toast.success(data.message);
      } else {
        toast.error("Error: " + data.message);
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Direct print setup incomplete.");
    }
  };

  const handlePrint = (reciptDetails, item, fullAddress) => {
    const formattedAddress = fullAddress.replace(/,/g, ",&nbsp;");
    const deliveryInfo =
      item.orderType === "home_delivery"
        ? `
        <p class="textSizeMid">
            Delivery Partner Name: ${item.delivery_person_name
          ? item.delivery_person_name
          : "Not assigned"
        }
        </p>
        <p class="textSizeMid">
            Delivery Partner Mobile No.: ${item.delivery_person_number
          ? item.delivery_person_number
          : "Not assigned"
        }
        </p>`
        : ""; // If it's not home delivery, leave it as an empty string.

    const printWindow = window.open("", "_blank");
    // HTML content for the customer receipt
    const customerReceiptHTML = `
        <html>
            <head>
                <style>
                    @page {
                        size: 80mm;
                        margin: 0;
                    }
                    body {
                        margin: 0;
                        margin-right:15px;
                        font-family: Arial, sans-serif;
                        font-size: 16px;
                        color: black;
                    }
                    .header {
                        display: flex;
                        flex-direction: column;
                        justify-content: center; 
                        align-items: center;         
                        text-align: center;            
                        color: #000;
                        line-height: 1.1;
                        border-bottom: 1px dashed #000;
                        margin-top: 0px;
                    }
                    .header2 {
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-start; 
                        align-items: flex-start;         
                        text-align: start;            
                        color: #000;
                       line-height: 1.5;
                        border-bottom: 1px dashed #000;
                        margin-top: 0px;
                        padding-bottom: 0px;
                    }
                    .headerTable {
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-start; 
                        align-items: flex-start;         
                        text-align: start;            
                        color: #000;
                        line-height: 1.2;
                        border-bottom: 1px dashed #000;
                        padding: 0;
                        margin: 0;
                    }
                    .headerTotal {
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-start; 
                        align-items: flex-start;
                        text-align: left;            
                        color: #000;
                        line-height: 1.5;
                        border-bottom: 1px dashed #000;
                        padding-bottom: 5px;
                        padding-top: 5px;
                        padding:0px;
                    }
                        .flex-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
                    .headerEnd {
                        text-align: center;            
                        color: #000; 
                        padding-bottom: 0px;
                    }
                    .textSizeLarge {
                        font-size: 16px;
                        margin: 1px;
                        padding: 1px;
                    }
                    .textSizeMid {
                        font-size: 12px;
                        margin: 0px;
                        padding: 0px;
                    }
                    .textSizeSmall {
                        font-size: 9px;
                        margin: 1px;
                        padding: 1px;
                    }
                    .order-details { width: 100%; border-collapse: collapse; }
                    .order-details th,
                    .order-details td { padding: 0px;  padding-top: 5px;  padding-bottom: 5px; font-size: 12px; text-align: left;  vertical-align: top; }
                    .table-text-center { text-align: center; }
                </style>
            </head>
            <body>
                <div class="container">
                    <div class="header">
                        <p class="textSizeLarge" style="font-weight: 600;">${reciptDetails.business_name
      }</p>
                        <p class="textSizeMid">${reciptDetails.address}</p>
                        <p class="textSizeMid">PH: ${reciptDetails.phone_no}</p>
                        <p class="textSizeMid">GST NO: ${reciptDetails.gst
      }</p>  
                        <p class="textSizeLarge" style="font-weight: 600;">** INVOICE **</p>
                    </div>
                    <div class="header2">
                        <p class="textSizeMid">Order No: ${item.daily_order_id
      } / ${item.orderid}</p>
                        <p class="textSizeMid">Order Type: ${item.orderType}</p>
                        <p class="textSizeMid">Customer Name: ${item.customer_name
      }</p>
                        <p class="textSizeMid">Customer Mobile: ${item.customer_mobile
      }</p>
                        <p class="textSizeMid">Payment Status: ${item.payment_status
      }</p>  
                          <p class="textSizeMid">Payment Mode: ${item.payment_mode
      }</p>
                        <p class="textSizeMid">Order Date: ${item.order_date
      }</p> 
                       ${deliveryInfo}

                       ${item.orderType === "home_delivery"
        ? `
  <p class="textSizeMid">Delivery Address: ${formattedAddress}</p>
`
        : ""
      }
                       
                       ${item.orderType === "dining"
        ? `
  <p class="textSizeMid">Table No: ${item.table_no}</p>
`
        : ""
      }
                    </div>
                    <div class="headerTable">
                        <table class="order-details" style=" border-collapse: collapse;">
                            <thead>
                                <tr>
                                    <th class="table-text-center" style=" padding-right:5px;">Sr.</th>
                                    <th class="table-text-center" sty>ITEM </th>
                                       <th class="table-text-center" sty>QTY </th>
                                    <th class="table-text-center" style="padding-left:5px; padding-right:5px;">PRC.</th>
                                    <th class="table-text-center">TTL.</th>
                                </tr>
                            </thead>
                           <tbody>
  ${item.items
        .map((subitem, index) => {
          let customizationText = "";

          try {
            const customization =
              subitem.customization && subitem.customization !== "{}"
                ? JSON.parse(subitem.customization)
                : null;

            if (customization) {
              const parts = Object.entries(customization).map(([key, value]) => {
                return `${Array.isArray(value) ? value.join(", ") : value}`;
              });
              customizationText = parts.length
                ? `<div class="custom-text">(${parts.join(" | ")})</div>`
                : "";
            }
          } catch {
            customizationText = `<div class="custom-text">(Invalid customization)</div>`;
          }

          return `
        <tr>
          <td class="table-text-center">${1 + index}</td>
          <td class="table-text-center">
            ${subitem.product_id}
            ${customizationText}
          </td> 
          
          <td class="table-text-center" style="padding-left:5px; ">
          ${subitem.quantity}
        
          </td>
         <td class="table-text-center" style="padding-left:5px; padding-right:5px;">${parseFloat(
            subitem.item_price
          )}</td>
<td class="table-text-center">${parseFloat(subitem.total_price)}</td>
        </tr>
      `;
        })
        .join("")}
</tbody>
                        </table>
                    </div>
                
                
         <div class="headerTotal">
    <div class="flex-row">
      <p class="textSizeMid" style="margin: 0px;">Sub Total ${item.gst_claim !== "Y" ? "(Tax Inc.)" : ""
      } :</p>
      <p class="textSizeMid" style="margin: 0px; text-align: right;">Rs. ${item.subtotal
      }</p>
    </div>

    ${item.coupon_applied
        ? `
      <div class="flex-row">
        <p class="textSizeMid" style="margin: 0px;">Coupon discount :</p>
        <p class="textSizeMid" style="margin: 0px; text-align: right;">Rs. ${Number(
          item.coupon_code_discount
        ).toFixed(2)}</p>
      </div>
    `
        : ""
      }

 ${item.loyalty_points_discount !== "0.00"
        ? `
      <div class="flex-row">
        <p class="textSizeMid" style="margin: 0px;">Loyalty Points Discount  :</p>
        <p class="textSizeMid" style="margin: 0px; text-align: right;">Rs. ${Number(
          item.loyalty_points_discount
        ).toFixed(2)}</p>
      </div>
    `
        : ""
      }
    ${item.discount_amount !== "0.00"
        ? `
      <div class="flex-row">
        <p class="textSizeMid" style="margin: 0px;">Discount Amount (${item.discount_percentage
        }%) :</p>
        <p class="textSizeMid" style="margin: 0px; text-align: right;">Rs. ${Number(
          item.discount_amount
        ).toFixed(2)}</p>
      </div>
    `
        : ""
      }

    ${item.gst_claim === "Y"
        ? `
      <div class="flex-row">
        <p class="textSizeMid" style="margin: 0px;">CGST (2.5%) :</p>
        <p class="textSizeMid" style="margin: 0px; text-align: right;">Rs. ${Number(
          item.tax_cgst
        ).toFixed(2)}</p>
      </div>
      <div class="flex-row">
        <p class="textSizeMid" style="margin: 0px;">SGST (2.5%) :</p>
        <p class="textSizeMid" style="margin: 0px; text-align: right;">Rs. ${Number(
          item.tax_sgst
        ).toFixed(2)}</p>
      </div>
    `
        : ""
      }

    <div class="flex-row">
      <p class="textSizeMid" style="margin: 0px;">Delivery Fee :</p>
      <p class="textSizeMid" style="margin: 0px; text-align: right;">Rs. ${item.delivery_fee
      }</p>
    </div>

    <div class="flex-row">
      <p class="textSizeMid" style="margin: 0px;">Other Fee :</p>
      <p class="textSizeMid" style="margin: 0px; text-align: right;">Rs. ${item.other_fee
      }</p>
    </div>

    <div class="flex-row font-weight-bold">
      <p class="textSizeMid" style="margin: 0px;font-weight: 600;">Total Amount :</p>
      <p class="textSizeMid" style="margin: 0px; text-align: right; font-weight: 600;">Rs. ${item.totalOrderPrice
      }</p>
    </div>
  </div>



                    <div class="header2">
                        <p class="textSizeMid" >Net Amount : Rs. ${item.totalOrderPrice
      }</p>
                        <p class="textSizeMid">Paid Amount : Rs. ${item.pay_amount
      }</p>
                     
                    </div>
                    <div class="headerEnd">
                        <p class="textSizeMid">Thank you for your purchase!</p>
                        <p class="textSizeSmall">* ${reciptDetails.tag_line1
      } *</p>
                    </div>
                </div>
            </body>
        </html>
    `;
    printWindow.document.write(customerReceiptHTML);
    printWindow.document.close(); // Close the document
    printWindow.focus(); // Focus on the new window
    printWindow.print(); // Trigger print for customer receipt
    printWindow.close(); // Close the print window after printing
  };

  const handleKitchenPrint = (reciptDetails, item, fullAddress) => {
    const formattedAddress = fullAddress.replace(/,/g, ",&nbsp;");
    const printWindow = window.open("", "_blank");

    // const orderKey = `printedOrders_${item.orderid}_${item.daily_order_id}`;
    const orderKey = `printedOrders_${item.orderid}`;

    // Retrieve printed items for this order from localStorage, or set an empty array if not found
    let printedItemsForOrder = JSON.parse(localStorage.getItem(orderKey)) || [];

    // Filter only items that haven't been printed yet for this specific order
    const unprintedItems = item.items.filter(
      (subitem) => !printedItemsForOrder.includes(subitem.id)
    );

    // If there are no unprinted items, exit the function
    if (unprintedItems.length === 0) {
      return;
    }

    // HTML content for the kitchen receipt
    const kitchenReceiptHTML = `
        <html>
            <head>
                <style>
                    @page {
                        size: 80mm;
                        margin: 0;
                    }
                    body {
                        margin: 0;
                         margin-right:15px;
                        font-family: Arial, sans-serif;
                        font-size: 12px;
                        color: black;
                    }
                    .header {
                        display: flex;
                        flex-direction: column;
                        justify-content: center; 
                        align-items: center;         
                        text-align: center;            
                        color: #000;
                        line-height: 1;
                        border-bottom: 1px dashed #000;
                        margin-top: 0px;
                    }
                    .header2 {
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-start; 
                        align-items: flex-start;         
                        text-align: start;            
                        color: #000;
                        line-height: 1.5;
                        border-bottom: 1px dashed #000;
                        margin-top: 0px;
                        padding-bottom: 0px;
                    }
                    .headerTable {
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-start; 
                        align-items: flex-start;         
                        text-align: start;            
                        color: #000;
                        line-height: 1.1;
                        border-bottom: 1px dashed #000;
                        padding: 0;
                        margin: 0;
                    }
                    .order-details { width: 100%; border-collapse: collapse; }
                    .order-details th, .order-details td { padding: 5px; font-size: 14px; text-align: left; }
                    .table-text-center { text-align: center; }
                </style>
            </head>
            <body>
                <div class="container">
          <div class="header" style="text-align: left;">
  <p class="textSizeLarge" style="font-weight: 600; margin: 5px 0;">${reciptDetails.business_name
      } - KITCHEN COPY</p>
  <p class="textSizeMid" style="margin: 5px 0;">
    <strong>Order No:</strong> <strong>${item.daily_order_id}</strong>
  </p>
  <p class="textSizeMid" style="margin: 5px 0;">Date: ${item.order_date}</p>
  <p class="textSizeMid" style="margin: 5px 0;">Order Type: ${item.orderType
      }</p>
    ${item.orderType === "dining"
        ? `
  <p class="textSizeMid">Table No: ${item.table_no}</p>
`
        : ""
      }
</div>
                    <div class="headerTable">
                        <table class="order-details" style="width: 100%; border-collapse: collapse;">
                            <thead>
                                <tr>
                                  <th class="table-text-center">Sr.</th>
                                    <th class="table-text-center">ITEM</th>
                                     <th class="table-text-center">QTY</th>
                                    <th class="table-text-center">PRICE</th>
                                </tr>
                            </thead>
        <tbody>
  ${unprintedItems
        .map((subitem, index) => {
          let customizationText = "";
          try {
            // Check if customization is null or "{}" and set to empty string if so
            const customization =
              subitem.customization && subitem.customization !== "{}"
                ? JSON.parse(subitem.customization)
                : null;

            if (customization) {
              const parts = Object.entries(customization).map(([key, value]) => {
                return ` ${Array.isArray(value) ? value.join(", ") : value}`;
              });
              customizationText = parts.length
                ? `<div class="custom-text">(${parts.join(" | ")})</div>`
                : "";
            }
          } catch {
            customizationText = `<div class="custom-text">(Invalid customization)</div>`;
          }

          return `
        <tr>
          <td>${index + 1}</td>
          <th>${subitem.product_id}${customizationText}</th>
       <th>${subitem.quantity}</th>
          <td>${parseFloat(subitem.item_price)}</td>
        </tr>
      `;
        })
        .join("")}
</tbody>
                        </table>
                    </div>
                    <div class="header2">
                        <p class="textSizeMid">Total Amount: Rs. ${item.totalOrderPrice
      }</p>
                    </div>
                </div>
            </body>
        </html>
    `;
    // Open a new window for the kitchen receipt
    printWindow.document.write(kitchenReceiptHTML);
    printWindow.document.close(); // Close the document
    printWindow.focus(); // Focus on the new window
    printWindow.print(); // Trigger print for kitchen receipt
    printWindow.close(); // Close the print window after printing
    const updatedPrintedItems = [
      ...printedItemsForOrder,
      ...unprintedItems.map((subitem) => subitem.id),
    ];
    // Save the updated printed items list in localStorage under the dynamic order key
    localStorage.setItem(orderKey, JSON.stringify(updatedPrintedItems));
  };
  const [summaryData, setSummaryData] = useState([]); // State to store API response
  const [totalDeliveryCharges, setTotalDeliveryCharges] = useState([]);
  const [error, setError] = useState(null); // State to store any error
  const [excelData, setExcelData] = useState([]);
  const summaryReportAPI = async () => {
    try {
      const requestBody = {
        userid: userID, // Ensure userID, startDate, and endDate are defined
        fromDate: endDate,
        toDate: endDate,
      };
      const response = await axios.post(
        `${baseUrl}/api/Order/getOrderSummaryData`,
        requestBody,
        config
      );
      if (response.data && response.data.responseCode === "00") {
        setSummaryData(response.data);
        const totalDeliveryChargesTemp = response.data.response
          .reduce((sum, item) => {
            return sum + parseFloat(item.charges);
          }, 0)
          .toFixed(2);
        setTotalDeliveryCharges(totalDeliveryChargesTemp);
        // Format data for Excel
        const formattedExcelData = response.data.response.map((item) => ({
          "Main Order ID": item.id,
          "Daily Order ID": item.daily_order_id,
          "Order Date": item.order_date,
          "Order Type": item.orderType,
          "Customer Name": item.customer_name,
          "Customer Mobile": item.customer_mobile,
          Charges: item.charges,
          GST: item.gst,
          "Total Price": item.totalOrderPrice,
          "Payment Status": item.payment_status,
        }));
        setExcelData(formattedExcelData);
      } else {
        setSummaryData([]);
        setExcelData([]);
        // toast.error(response.data.responseMessage);
        setError(
          response.data.responseMessage || "Failed to fetch summary data"
        ); // Handle API error
      }
    } catch (error) {
      setError("Error making API call"); // Handle request failure
      console.error("Error making API call:", error);
    }
  };
  const handleDownload = () => {
    if (!excelData || excelData.length === 0) {
      alert("No data available to download!");
      return;
    }
    // Prepare data for Excel
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Summary Report");
    const excelDataBlob = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelDataBlob], {
      type: "application/octet-stream",
    });
    saveAs(blob, `Summary_Report_${startDate}_to_${endDate}.xlsx`);
  };
  useEffect(() => {
    summaryReportAPI();
  }, [startDate, endDate]); // Only runs once on mount
  const printReceiptSUMMARY = (
    summaryData,
    reciptDetails,
    startDate,
    endDate,
    totalDeliveryCharges
  ) => {
    const formattedReceiptHTML = `
    <html>
    <head>
      <style>
      body { font-family: Arial, sans-serif;  }
      .container { max-width:600px;  }
       .header {
  display: flex;
  flex-direction: column;
  justify-content: center; 
  align-items: center;         
  text-align: center;            
  color: #000;
  line-height: 1.1;
  border-bottom: 1px dashed #000;
  margin-top: 10px;
}
.header2 {
  display: flex;
  flex-direction: column; /* Stack sameline divs vertically */
  align-items: flex-start;         
  text-align: start;            
  color: #000;
  line-height: 1.5;
  border-bottom: 1px dashed #000;
  margin-top: 5px;
  padding-bottom: 5px;
  width: 100%; /* Ensure the header2 div spans the full width */
  box-sizing: border-box; /* Include padding and border in element's total width */
}
.sameline {
  display: flex;
  justify-content: center; /* Space items within sameline div */
  width: 100%; /* Ensure sameline items span full width */
  overflow: hidden; /* Prevent content from overflowing */
  white-space: nowrap; /* Prevent text from wrapping */
}



.single-line-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

 .headerTable {
  display: flex;
  flex-direction: column;
  justify-content: flex-start; 
  align-items: space-between;         
  text-align: start;            
  color: #000;
  line-height: 1.1;
  border-bottom: 1px dashed #000;
  padding:0px;
  margin:0px;
}


  .headerTotal {
  display: flex;
  flex-direction: column;
  justify-content: flex-start; 
  align-items: flex-start;         
  text-align: start;            
  color: #000;
  line-height: 1.1;
  border-bottom: 1px dashed #000;
  padding-top:5px;
  padding-bottom:5px;
}
.headerEnd {       
  text-align: center;            
  color: #000; 
   padding-bottom: 5px;
}
.textSizeLarge {
font-size: 16px;
margin: 1px; /* Remove margin */
padding: 1px; /* Remove padding */
}
.textSizeMid {
font-size: 10px;
margin: 1px; /* Remove margin */
padding: 1px; /* Remove padding */
}
.textSizeSmall {
font-size: 9px;
margin: 1px; /* Remove margin */
padding: 1px; /* Remove padding */
}
.textWhite{
color:#fff;
}
.receipt-header {
display: flex;
justify-content: space-between;
align-items: flex-start;
margin-top:15px;
}
.single-line-report{
  white-space: nowrap;
}
.left-side {
text-align: left;
}
.right-side {
text-align: right;
}
.business-name{
margin: 0;
padding: 0;
color:#000;
font-size:16px;
}
.address{
margin: 0;
padding: 0;
color:#000;
  font-size:10px;
}
.phone-number{
margin: 0;
padding: 0;
color:#000;
  font-size:10px;
} 
.gst-number {
margin: 0;
padding: 0;
color:#000;
  font-size:10px;
}
.space-between-columns {
  display: flex;
  justify-content: space-between;
  align-items: center; /* Aligns the text vertically in the center */
  width: 100%; /* Ensures the flexbox spans the full width of the table header */
}
      .order-details { width: 100%; border-collapse: collapse; }
      .order-details th,
       .order-details td { padding: 5px;font-size: 10px; text-align: left;}
      .order-details2 th, 
      .order-details2 td { 
      
        padding-top:5px;
  padding-bottom:5px;
      font-size: 10px; text-align: left;}
      .total-row { font-weight: bold; }
     .table-text-center {
  text-align: center !important;
}
    </style>
    </head>
    <body>
      <div class="container">
         <div class="header">
<p class="textSizeLarge" style=" font-weight: 600;">${reciptDetails.business_name
      }</p>
<p class="textSizeMid" > ${reciptDetails.address}</p>
<p class="textSizeMid" >PH: ${reciptDetails.phone_no}</p>
<p class="textSizeMid" >GST NO: ${reciptDetails.gst}</p>  
<p class="textSizeLarge" style=" font-weight: 600;">** SUMMARY REPORT **</p>
</div>
<div class="header2">
<div class="sameline">
<div class="textSizeMid single-line-text " >Date :  ${summaryData.fromDate
      }</div>

</div>

</div>

        <div class="headerTable" style="text-align: center;">
          <table class="order-details2">
            <thead>
              <tr>

                <th class="table-text-center single-line-text">ODR.ID</th>
                <th class="table-text-center">MOD</th>

                <th class="table-text-center single-line-report">NAME</th>
                
                <th class="table-text-center single-line-report"> PRICE</th>
              </tr>
            </thead>
          <tbody>
  ${summaryData.response
        .map((item, index) => {
          const orderTypeFormatted =
            item.orderType === "takeway"
              ? "Tkwy"
              : item.orderType === "home_delivery"
                ? "H.Del"
                : item.orderType === "dining"
                  ? "Dine"
                  : item.orderType;

          return `
        <tr>
          
          <td class="table-text-center">${item.daily_order_id}/${item.orderid
            } (${orderTypeFormatted})</td>
           <td class="table-text-center">${item.payment_mode}</td>
            
          <td class="table-text-center">${item.customer_name}</td>
          <td class="table-text-center">${parseFloat(
              item.totalOrderPrice
            ).toFixed(2)}</td>
        </tr>
      `;
        })
        .join("")}
</tbody>
          </table>
        </div>
         
        <div class="headerTotal">
          <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; font-weight: 500;">
                            <p class="textSizeMid" style="margin: 0;">Total Cash Collected Amount :</p>
                            <p class="textSizeMid" style="margin: 0;">Rs.  ${summaryData.data2.totalCashCollectedAmount}</p>
                        </div>
          <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; font-weight: 500;">
                            <p class="textSizeMid" style="margin: 0;">Total UPI Collected Amount :</p>
                            <p class="textSizeMid" style="margin: 0;">Rs.  ${summaryData.data2.totalUPICollectedAmount}</p>
                        </div>
                                  <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; font-weight: 500;">
                            <p class="textSizeMid" style="margin: 0;">Total Card Collected Amount :</p>
                            <p class="textSizeMid" style="margin: 0;">Rs.  ${summaryData.data2.totalCardCollectedAmount}</p>
                        </div>
        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; font-weight: 600;">
                            <p class="textSizeMid" style="margin: 0;">Total Order Amount :</p>
                            <p class="textSizeMid" style="margin: 0;">Rs. ${summaryData.totalSummaryAmount
      }</p>
                        </div>

                          
      
      </div>

         <div class="headerTotal">
          

                           <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; font-weight: 500;">
                            <p class="textSizeMid" style="margin: 0;">Total Delivery Charges :</p>
                            <p class="textSizeMid" style="margin: 0;">Rs.  ${summaryData.data2.totalDeliveryCharges}</p>
                        </div>
                                    <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; font-weight: 500;">
                            <p class="textSizeMid" style="margin: 0;">Total Platform Fee :</p>
                            <p class="textSizeMid" style="margin: 0;">Rs.  ${summaryData.data2.totalPlatformCharges}</p>
                        </div>
                                    <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; font-weight: 500;">
                            <p class="textSizeMid" style="margin: 0;">Total Message Charges :</p>
                            <p class="textSizeMid" style="margin: 0;">Rs.  ${summaryData.data2.totalMessageCharges}</p>
                        </div>
      
      </div>
          <div class="headerEnd">
  <div class="textSizeSmall" style="padding-top: 5px;  margin-top: 10px;">
    <p style="margin: 0;">Order Type Legends:</p>
    <p style="margin: 0;">Tkwy = Takeaway | H.Del = Home Delivery | Dine = Dining</p>
  </div>
  <p class="textSizeMid">** END OF SUMMARY REPORT **</p>
</div>
      </div>
    </body>
    </html>

    `;

    const printWindow = window.open("", "_blank");
    printWindow.document.write(formattedReceiptHTML);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  const assignDoorDashApi = async (modalData) => {
    console.log(modalData);
    try {
      const requestBody = { orderId: modalData.orderid };

      const response = await axios.post(
        `${baseUrl}/api/Doordash/acceptQuote`,
        requestBody,
        config
      );
      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);
        handleCloseModal();
      } else {
        toast.error(response.data.responseMessage);
        handleCloseModal();
      }
    } catch {
      console.log("Error");
    }
  };

  const resetModalState = () => {
    setSelectedPartnerType("packky");
    setSelectedDeliveryPartner(null);
    setFullAddressState("");
    setDeliveryPersonDetails(null);
    setShowDoorDashConfirmation(false);
  };

  const handleCloseModal = () => {
    resetModalState(); // Reset all states to initial values
    setShowModal(false); // Close the modal
  };

  const resetDeliveryModalState = () => {
    setDeliveryInfo(null);
    setCurrentOrderId("");
    setStatusDriver("");
  };

  const handleViewTrackingDetails = () => {
    if (deliveryInfo && deliveryInfo.tracking_url) {
      window.open(deliveryInfo.tracking_url, "_blank");
    }
  };
  //  Kewal code
  function getStatusDetails(status) {
    // console.log(status);
    switch (status) {
      case "driver_assigned":
        return {
          backgroundColor: "#E0EFFF", // Light Blue
          textColor: "#0056b3", // Dark Blue
          displayName: "Driver Assigned",
        };
      case "driver_confirmed":
        return {
          backgroundColor: "#CCE7D0", // Light Green
          textColor: "#2F6D32", // Dark Green
          displayName: "Driver Confirmed",
        };
      case "driver_pickup_arrival":
        return {
          backgroundColor: "#FFF3E0", // Light Orange
          textColor: "#B25800", // Dark Orange
          displayName: "Driver at Pickup",
          fontSize: "0.6rem",
        };
      case "delivery_picked":
        return {
          backgroundColor: "#FFE0E0", // Light Red
          textColor: "#B30000", // Dark Red
          displayName: "Delivery Picked",
        };
      case "driver_dropoff_arrival":
        return {
          backgroundColor: "#E8E0FF", // Light Purple
          textColor: "#4A00B3", // Dark Purple
          displayName: "Driver at Drop-off",
        };
      case "dispatched":
        return {
          backgroundColor: "#E8E0FF", // Light Purple
          textColor: "#4A00B3", // Dark Purple
          displayName: "Dispatched",
        };
      case "completed":
      case "delivered":
      case "ready_for_takeway":
      case "ready_for_dinning":
        return {
          backgroundColor: "rgba(242, 252, 248, 1)", // Default background for completed
          textColor: "rgba(1, 195, 125, 1)",
          // Text color for completed
          displayName: "Completed",
        };
      default:
        return {
          backgroundColor: "rgba(242, 252, 248, 1)", // Default background color
          textColor: "#DC3545", // Default text color (e.g., Bootstrap's text-danger)
          displayName: "NA",
        };
    }
  }

  const StatusSpan = ({ item }) => {
    const statusDetails = getStatusDetails(item.status);

    return (
      <div
        className="text-center w-100 px-3 py-1 single-line-css"
        style={{
          width: "91px",
          height: "31px",
          borderRadius: "50px",
          backgroundColor: statusDetails.backgroundColor,
          color: statusDetails.textColor,
          fontWeight: "bold",
          fontSize: statusDetails.fontSize,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {statusDetails.displayName}
      </div>
    );
  };

  const handleDriverStatusChange = async (
    event,
    orderID,
    item,
    fullAddress
  ) => {
    const selectedStatus = event.target.value;
    setStatusDriver(selectedStatus);

    if (selectedStatus && selectedStatus !== "Please select") {
      setIsFoodReadyLoading(true);
      try {
        const requestBody = {
          userid: userID,
          orderId: orderID,
          orderStatus: selectedStatus,
          deliveryPartner: "packky",
        };

        const response = await axios.post(
          `${baseUrl}/api/Delivery/v1.0/notifyDriver`,
          requestBody,
          config
        );

        if (response.data.responseCode === "00") {
          toast.success(response.data.responseMessage);
          setIsDeliveryModalOpen(false);
          resetDeliveryModalState();
          setShowModal(false);
          getNewOrder();
          OrderHistoryAPI();
          // Call heavy API only after successful status update
          try {
            await sendOrderReciptApi(item, orderID, fullAddress);
          } catch (receiptError) {
            console.error("Error sending order receipt:", receiptError);
            toast.error("Failed to send order receipt.");
          }
        } else {
          toast.error(response.data.responseMessage);
        }
      } catch (error) {
        console.error("Error updating status:", error);
      } finally {
        setIsFoodReadyLoading(false);
      }
    }

    // sendOrderReciptApi(item, orderID, fullAddress);
  };
  const [paymentOrderId, setPaymentOrderId] = useState("");
  const [totalOrderAmount, setTotalOrderAmount] = useState("");

  const [showPaymentmodelModal, setShowPaymentmodelModal] = useState(false);
  const [paymentmodelPaymentMode, setPaymentmodelPaymentMode] = useState("");
  const [paymentmodelCollectedBy, setPaymentmodelCollectedBy] = useState("Restaurant");
  const [paymentmodelRemarks, setPaymentmodelRemarks] = useState("");
  const resetPaymentmodelState = () => {
    setPaymentmodelPaymentMode("");
    setPaymentmodelCollectedBy("Restaurant");
    setPaymentmodelRemarks("");
  };

  const handlePaymentmodelSubmit = async () => {
    if (!paymentmodelPaymentMode || !paymentmodelCollectedBy) {
      alert("Please fill in all required fields");
      return;
    }

    try {
      const requestBody = {
        userid: userID,
        orderid: paymentOrderId,
        productid: "string",
        status: "cash_collected",
        time: "string",
        payment: paymentmodelPaymentMode,
        paymentCollectedBy: paymentmodelCollectedBy,
        remarks: paymentmodelCollectedBy,
      };

      const response = await axios.post(
        `${baseUrl}/api/Whatsapp/changeCatelogOrderStatus`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        // Optional: handle data if needed, e.g., update UI
        // setCurrentCatalogueStatus(response.data.data.message);
        toast.success(response.data.responseMessage);
        setShowPaymentmodelModal(false);
        resetPaymentmodelState();
        getNewOrder();
      } else {
        alert(response.data.responseMessage || "Something went wrong");
      }
    } catch (error) {
      alert("Failed to change payment mode");
      console.error(error);
    }
  };

  return (
    <div className="p-4 light marginRight" style={{ fontFamily: "Nunito, sans-serif" }}>

      <NoIndex />
      <Modal
        show={showPaymentmodelModal}
        onHide={() => {
          setShowPaymentmodelModal(false);
          resetPaymentmodelState();
        }}
        size="lg"
        aria-labelledby="paymentmodel-modal-title"
        className="paymentmodel-modal"
        centered
      >
        <Modal.Header closeButton className="bg-light border-bottom">
          <Modal.Title id="paymentmodel-modal-title" className="fw-bold fs-4">
            Cash Collection
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* Step-by-step guidance */}


          {/* Order Amount */}
          <div className="text-center mb-4">
            <h1 className="text-success fw-bold display-4">₹{totalOrderAmount}</h1>
            <div className="text-muted fs-5">Order Amount to Collect</div>
          </div>

          <hr />

          <Form >
            {/* Payment Mode */}
            <Form.Group className="mb-5">
              <Form.Label className="fs-5 fw-semibold">Payment Mode</Form.Label>
              {/* <div className="text-muted mb-2">
          Please select how the customer paid.
        </div> */}

              <div className="d-flex gap-3 flex-wrap mt-2">
                <label
                  className={`btn btn-outline-primary  text-bold  fs-5 py-2 px-4 border border-primary  ${paymentmodelPaymentMode === "cod" ? "active" : ""
                    }`}
                  style={{
                    minWidth: "120px",
                    textAlign: "center",
                    cursor: "pointer",
                  }}
                >
                  <input
                    type="radio"
                    name="paymentmodelPaymentMode"
                    value="cod"
                    checked={paymentmodelPaymentMode === "cod"}
                    onChange={(e) => setPaymentmodelPaymentMode(e.target.value)}
                    className="d-none "
                  />
                  Cash
                </label>

                <label
                  className={`btn btn-outline-primary  fs-5 py-2 px-4 border border-primary ${paymentmodelPaymentMode === "Card" ? "active" : ""
                    }`}
                  style={{
                    minWidth: "120px",
                    textAlign: "center",
                    cursor: "pointer",
                  }}
                >
                  <input
                    type="radio"
                    name="paymentmodelPaymentMode"
                    value="Card"
                    checked={paymentmodelPaymentMode === "Card"}
                    onChange={(e) => setPaymentmodelPaymentMode(e.target.value)}
                    className="d-none"
                  />
                  Card Payment
                </label>
              </div>


            </Form.Group>

            {/* Collected By */}
            <Form.Group className="mb-5">
              <Form.Label className="fs-5 fw-semibold">Collected By</Form.Label>
              {/* <div className="text-muted mb-2">
                Select who collected the payment 
              </div> */}
              <div className="d-flex gap-3 flex-wrap mt-2">
                {["Restaurant", "Delivery Partner"].map((option) => {
                  const isDisabled = option === "Delivery Partner";
                  const colorClass = option === "Restaurant"
                    ? "btn-outline-primary"
                    : "btn-outline-secondary";

                  return (
                    <label
                      key={option}
                      className={`btn ${colorClass} fs-5 py-2 px-4 border  ${paymentmodelCollectedBy === option ? "active" : ""
                        } ${isDisabled ? "disabled text-muted" : ""}`}
                      style={{
                        minWidth: "180px",
                        textAlign: "center",
                        cursor: isDisabled ? "not-allowed" : "pointer",
                        opacity: isDisabled ? 0.5 : 1,
                      }}
                      title={isDisabled ? "Only Restaurant staff can collect cash" : ""}
                    >
                      <input
                        type="radio"
                        name="paymentmodelCollectedBy"
                        value={option}
                        checked={paymentmodelCollectedBy === option}
                        onChange={(e) =>
                          !isDisabled && setPaymentmodelCollectedBy(e.target.value)
                        }
                        className="d-none"
                        disabled={isDisabled}
                      />
                      {option}
                    </label>
                  );
                })}
              </div>
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer className="border-top">
          <Button
            variant="outline-secondary"
            onClick={() => {
              setShowPaymentmodelModal(false);
              resetPaymentmodelState();
            }}
          >
            Cancel
          </Button>
          <Button
            variant="success"
            onClick={handlePaymentmodelSubmit}
          // disabled={!paymentmodelPaymentMode}
          >
            Confirm & Collect ₹{totalOrderAmount}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={isDeliveryModalOpen}
        onHide={() => {
          setIsDeliveryModalOpen(false);
          resetDeliveryModalState();
        }}
        size="lg"
        aria-labelledby="delivery-modal-title"
        className="custom-delivery-modal" // Unique class for the modal
      >
        <Modal.Header
          closeButton
          className="custom-modal-header bg-light text-dark"
        >
          <Modal.Title id="delivery-modal-title">
            Track Order Delivery
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="custom-modal-body text-center">
          {isLoadingDeliveryDetails ? (
            <Spinner animation="border" variant="primary" />
          ) : deliveryError ? (
            <div className="alert alert-danger custom-error-alert">
              {deliveryError}
            </div>
          ) : deliveryInfo ? (
            <div>
              <h5 className="mb-4 custom-delivery-info-title">
                Delivery Information
              </h5>
              <p>
                <strong>Order ID:</strong> {deliveryInfo.external_delivery_id}
              </p>
              <p>
                <strong>Status:</strong>{" "}
                <span className="text-success">
                  {deliveryInfo.delivery_status}
                </span>
              </p>
              <p>
                <strong>Pickup Address:</strong> {deliveryInfo.pickup_address}
              </p>
              <p>
                <strong>Dropoff Address:</strong> {deliveryInfo.dropoff_address}
              </p>
              <p>
                <strong>Order Value:</strong> {deliveryInfo.order_value}{" "}
                {deliveryInfo.currency}
              </p>
              <Button variant="success" onClick={handleViewTrackingDetails}>
                View Tracking Details
              </Button>
            </div>
          ) : null}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setIsDeliveryModalOpen(false);
              resetDeliveryModalState();
              setStatusDriver("");
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
          resetModalState();
        }}
        size="lg" // Makes the modal larger
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {modalData.orderType === "home_delivery"
              ? "Home Delivery"
              : modalData.orderType === "takeway"
                ? "Takeaway"
                : "Dining"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalData.orderType === "home_delivery" && (
            <div>
              {/* {JSON.stringify(modalData)} */}
              {/* Select Delivery Partner Type */}
              <div className="bg-light border-15-only p-2 ">
                <span className="text-3-2">Delivery Address : </span>
                <span className="text-3-2-dark">{fullAddressState}</span>
              </div>
              <hr />
              <div className="pb-3">
                <h5 className="section-title">Select Delivery Service Type</h5>
                <div className="d-flex justify-content-around mt-4 delivery-partner-options">
                  <label
                    className={`partner-option ${selectedPartnerType === "packky" ? "selected" : ""
                      }`}
                    onClick={() => setSelectedPartnerType("packky")}
                  >
                    <input
                      type="radio"
                      name="partnerType"
                      value="packky"
                      checked={selectedPartnerType === "packky"}
                      onChange={() => setSelectedPartnerType("packky")}
                      className="me-2 visually-hidden"
                    />
                    <span className="option-label">
                      Packky Delivery Service
                    </span>
                  </label>

                  <label
                    className={`partner-option ${selectedPartnerType === "restaurant" ? "selected" : ""
                      }`}
                    onClick={() => setSelectedPartnerType("restaurant")}
                  >
                    <input
                      type="radio"
                      name="partnerType"
                      value="restaurant"
                      checked={selectedPartnerType === "restaurant"}
                      onChange={() => setSelectedPartnerType("restaurant")}
                      className="me-2 visually-hidden"
                    />
                    <span className="option-label">
                      Restaurant Delivery Service
                    </span>
                  </label>

                  <label
                    className={`partner-option ${selectedPartnerType === "doordash" ? "selected" : ""
                      }`}
                    onClick={() => {
                      setShowDoorDashConfirmation(true);
                      setSelectedPartnerType("doordash");
                    }}
                  >
                    <input
                      type="radio"
                      name="partnerType"
                      value="doordash"
                      checked={selectedPartnerType === "doordash"}
                      onChange={() => setSelectedPartnerType("doordash")}
                      className="me-2 visually-hidden"
                    />
                    <span className="option-label">
                      DoorDash Delivery Service
                    </span>
                  </label>
                </div>
                <hr />
              </div>
              {/* Conditionally render based on selected delivery partner type */}
              {selectedPartnerType === "restaurant" ? (
                <div>
                  {deliveryPartnerList.map((item) => (
                    <label
                      key={item.id}
                      onClick={() => handleDeliveryPartnerSelection(item)}
                      className={`cursor-pointer border-15-only my-2 p-3 d-block ${item.id === selectedDeliveryPartner
                        ? "bg-light-blue outline-primary text-primary"
                        : "bg-light"
                        }`}
                      style={{ border: "1px solid #F8F9FA" }}
                    >
                      <div className="d-flex align-items-center">
                        <input
                          type="radio"
                          name="deliveryPartner"
                          value={item.id}
                          checked={item.id === selectedDeliveryPartner}
                          onChange={() => handleDeliveryPartnerSelection(item)}
                          className="me-2"
                          style={{ pointerEvents: "none" }}
                        />
                        <div className="ps-2">
                          <span className="text-3-2 text-dark">
                            {item.contact_name}
                          </span>
                          <span className="ps-3">
                            {item.active_order_count > 0 ? (
                              <span className="text-danger bg-white px-2">
                                {item.active_order_count} Active Orders
                              </span>
                            ) : (
                              <span className="text-success bg-white px-2">
                                Available
                              </span>
                            )}
                          </span>
                          <div>Delivery area: {item.location}</div>
                        </div>
                      </div>
                    </label>
                  ))}
                </div>
              ) : (
                // Confirmation for DoorDash
                selectedPartnerType === "doordash" && (
                  <div className="text-center py-4">
                    <div className="doorDashConfirmationModal">
                      <h4 className="doorDashModalTitle mb-4 text-primary">
                        Delivery Partner Confirmation
                      </h4>
                      <strong className="doorDashConfirmationMessage">
                        Are you sure you want to assign the delivery partner
                        through
                        <span className="text-danger"> DoorDash?</span>
                      </strong>
                      {/* <div className="doorDashModalDescription mt-4">
                        <p className="text-muted">
                          Please confirm that you want to proceed with DoorDash for your
                          delivery needs. This action cannot be undone.
                        </p>
                      </div> */}
                      <div className="doorDashModalButtonGroup mt-4">
                        <Button
                          onClick={() => {
                            assignDoorDashApi(modalData);
                            setShowDoorDashConfirmation(false);
                            setSelectedPartnerType("doordash");
                          }}
                          className="btn btn-primary me-3 rounded-pill px-4 doorDashConfirmButton"
                        >
                          Yes, Assign DoorDash
                        </Button>
                        <Button
                          onClick={() => {
                            setShowDoorDashConfirmation(false);
                            setSelectedPartnerType(null); // Reset selection
                          }}
                          className="btn btn-secondary rounded-pill px-4 doorDashCancelButton"
                        >
                          No, Cancel
                        </Button>
                      </div>
                    </div>
                  </div>
                )
              )}

              {/* Handling the confirmation state */}
              {selectedPartnerType === "packky" && (
                <div className="d-flex flex-column align-items-center justify-content-center py-4">
                  {modalData.delivery_partner_status === "acknowledged" ? (
                    <>
                      <div
                        className="card shadow-sm p-4 rounded-3 border-0 w-50"
                        style={{ backgroundColor: "#f8f9fa" }}
                      >
                        <h5 className="text-primary fw-bold mb-3 text-center">
                          Mark Food is Ready
                        </h5>

                        <p className="text-secondary text-center mb-4">
                          Click the button below when the food is packed and
                          ready. This will let the delivery partner know it's
                          time to pick it up.
                        </p>

                        <Form.Group controlId="statusButton">
                          <div className="d-flex justify-content-center align-items-center">
                            <Button
                              variant="success"
                              className="shadow-sm border-0 p-2 px-5"
                              style={{
                                backgroundColor: isFoodReadyLoading
                                  ? "#218838"
                                  : "#28a745",
                                cursor: isFoodReadyLoading
                                  ? "not-allowed"
                                  : "pointer",
                                opacity: isFoodReadyLoading ? 0.8 : 1,
                              }}
                              disabled={isFoodReadyLoading}
                              onClick={() =>
                                handleDriverStatusChange(
                                  { target: { value: "food is ready" } },
                                  modalData.orderid,
                                  modalData,
                                  fullAddressState
                                )
                              }
                            >
                              {isFoodReadyLoading ? (
                                <>
                                  <span
                                    className="spinner-border spinner-border-sm me-2"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                  Processing...
                                </>
                              ) : (
                                "Food is Ready"
                              )}
                            </Button>
                          </div>
                        </Form.Group>
                      </div>
                    </>
                  ) : modalData.delivery_partner_status === "food is ready" ? (
                    <div
                      className="card shadow-sm p-4 rounded-3 border-0 w-50"
                      style={{ backgroundColor: "#e2f0d9" }}
                    >
                      <h5 className="text-success fw-bold mb-3 text-center">
                        Delivery partner has been assigned
                      </h5>
                      <div className="  bg-white p-4  border-15-only mt-3  order-table-delivery-height">
                        <h3 className="text-3-2-dark">
                          Delivery Partner Details
                        </h3>
                        <div className="text-gray-700">
                          <p className="mb-1">
                            <strong>Name:</strong>{" "}
                            {modalData.delivery_person_name}
                          </p>
                          <p className="mb-1">
                            <strong>Contact:</strong>{" "}
                            {modalData.delivery_person_number}
                          </p>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div
                        className="card shadow-sm p-4 rounded-3 border-0 w-50"
                        style={{ backgroundColor: "#f8f9fa" }}
                      >
                        <h5 className="text-danger fw-bold mb-3 text-center">
                          Waiting for delivery partner
                        </h5>
                        <p className="text-secondary text-center mb-0">
                          We're currently waiting for the delivery boy to get
                          assigned and start the delivery process.
                        </p>
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>
          )}

          {modalData.orderType === "takeway" && (
            <div>
              <strong>Takeaway Order</strong>
              <br />
              <span>Please prepare the order for pickup.</span>
            </div>
          )}
          {modalData.orderType === "dining" && (
            <div>
              <strong>Dining Order</strong>
              <br />
              <span>Order will be served in the restaurant.</span>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {modalData.orderType === "home_delivery" &&
            selectedPartnerType !== "doordash" &&
            selectedPartnerType !== "packky" && (
              <Button
                onClick={() =>
                  assignDeliveryPartner(
                    modalData,
                    selectedDeliveryPartner,
                    fullAddressState,
                    deliveryPersonDetails
                  )
                }
                disabled={!selectedDeliveryPartner}
                className="bg-white btn-outline-primary text-primary"
              >
                Assign Delivery Partner
              </Button>
            )}
          {modalData.orderType === "takeway" && (
            <Button
              onClick={() =>
                TakeWayOrderApi(modalData, modalData.orderid, fullAddressState)
                  .then(() => setShowModal(false))
                  .catch((error) =>
                    console.error("Error dispatching takeaway order:", error)
                  )
              }
              className="bg-white btn-outline-primary text-primary"
            >
              Ready For Takeaway
            </Button>
          )}
          {modalData.orderType === "dining" && (
            <Button
              onClick={() => diningOrderApi(modalData)}
              className="bg-white btn-outline-primary text-primary"
            >
              Ready for Dining
            </Button>
          )}
          <Button
            variant="secondary"
            onClick={() => {
              setShowModal(false);
              resetModalState();
            }}
            className="bg-white btn-outline-dark text-dark"
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="d-flex justify-content-center text-center">
        <ToastContainer />
      </div>
      <div className="bg-white px-4" style={{ borderRadius: "10px" }}>
        <div className="d-flex justify-content-between align-items-center border-15-only px-2  py-1">
          <div className="CreateCampaign">Orders Management</div>



          <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
            {/* Order Settings Button */}
            <div className="me-3">
              <button
                className="btn text-white py-2 px-4 position-relative shadow-sm bg-green-order"
                onClick={() => navigate("/admin/order/orderssettings")}
                style={{
                  fontWeight: "600",
                  border: "0px solid #198754",
                  transition: "all 0.3s ease",
                }}
              >
                Order Settings
                <span
                  className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-warning text-dark"
                  style={{ fontSize: "0.65rem" }}
                >
                  New
                </span>
              </button>
            </div>

            {/* Order Accepting Toggle */}
            {currentCatalogueStatus && (
              <div className="d-flex align-items-center border p-2 bg-light rounded-3 shadow-sm">
                <div className="me-3">
                  <span className="text-3-2 fw-semibold">Order Accepting</span>
                </div>
                <div className="order-switch d-flex align-items-center cursor-pointer">
                  <label className="order-switch-label mb-0">
                    <input
                      type="checkbox"
                      checked={currentCatalogueStatus === "show"}
                      onChange={handleToggle}
                    />
                    <span
                      className={`order-slider order-round ms-2 ${currentCatalogueStatus === "hide" ? "off" : "on"
                        }`}
                    >
                      {currentCatalogueStatus === "hide" ? "OFF" : "ON"}
                    </span>
                  </label>
                </div>
              </div>
            )}
          </div>
        </div>
        {loading ? (
          <div className="m-5 p-5 d-flex justify-content-center">
            <div className="loader"></div>
          </div>
        ) : (
          <>
            {orders ? (
              <>
                <ul className="nav">
                  <li className="nav-item">
                    <button
                      className={`nav-link px-4 ${activeTab === "home-tab"
                        ? "active active-underline bg-green-order text-white "
                        : "gray-underline"
                        }`}
                      id="home-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#home-tab-pane"
                      type="button"
                      role="tab"
                      aria-controls="home-tab-pane"
                      aria-selected="true"
                      style={{
                        color: "#01C37D",
                        background: "none",
                        border: "none",
                      }}
                      onClick={() => {
                        setActiveTab("home-tab");
                        setOpenRowIndex_NewOrder(null);
                        setOpenRowIndex_History(null);
                        setOpenRowIndex_Active(null);
                      }}
                    >
                      Current Order{" "}
                      {/* <span className="text-white mx-2 circle-order ">
                        {countNewOrder}
                      </span> */}
                    </button>
                  </li>
                  <li className="nav-item" style={{ color: "black" }}>
                    <button
                      className={`nav-link px-4  ${activeTab === "order-history-tab"
                        ? "active active-underline bg-green-order text-white"
                        : "gray-underline"
                        }`}
                      id="order-history-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#order-history-tab-pane"
                      type="button"
                      role="tab"
                      aria-controls="order-history-tab-pane"
                      aria-selected="false"
                      style={{
                        color: "#01C37D",
                        background: "none",
                        border: "none",
                      }}
                      onClick={() => {
                        setActiveTab("order-history-tab");
                        setOpenRowIndex_NewOrder(null);
                        setOpenRowIndex_History(null);
                        setOpenRowIndex_Active(null);
                      }}
                    >
                      Order History
                      {/* <span className="text-white mx-2 circle-order ">{countOrderHistory}</span> */}
                      {/* <span className="text-white mx-2 circle-order bg-white">
                        .
                      </span> */}
                    </button>
                  </li>
                </ul>
                <div className="tab-content p-0 py-2" id="myTabContent">
                  {/* New Order */}
                  <div
                    className="tab-pane fade show active"
                    id="home-tab-pane"
                    role="tabpanel"
                    aria-labelledby="home-tab"
                  >
                    <div className="  d-flex justify-content-between gap-3">
                      <div>
                        <button
                          onClick={() => {
                            setOrderFilter("newplusactive");
                          }}
                          className={`${orderFilter === "newplusactive"
                            ? "btn bg-white btn-outline-primary text-primary "
                            : "btn bg-white btn-outline-dark text-dark "
                            } `}
                        >
                          Active + Initiated Orders{" "}
                        </button>
                      </div>

                      <div>
                        <button
                          onClick={() => {
                            setOrderFilter("active");
                          }}
                          className={`${orderFilter === "active"
                            ? "btn bg-white btn-outline-primary text-primary "
                            : "btn bg-white btn-outline-dark text-dark "
                            }`}
                        >
                          Active Orders Only{" "}
                        </button>
                      </div>
                      <div>
                        <button
                          onClick={() => {
                            setOrderFilter("dining");
                          }}
                          className={`${orderFilter === "dining"
                            ? "btn bg-white btn-outline-primary text-primary "
                            : "btn bg-white btn-outline-dark text-dark "
                            }`}
                        >
                          Dining{" "}
                        </button>
                      </div>

                      <div>
                        <button
                          onClick={() => {
                            setOrderFilter("rejected");
                          }}
                          className={`${orderFilter === "rejected"
                            ? "btn bg-white btn-outline-primary text-primary "
                            : "btn bg-white btn-outline-dark text-dark "
                            }`}
                        >
                          Rejected{" "}
                        </button>
                      </div>
                      <div><select class="form-select " aria-label="Small select example" onChange={(e) => setuserID(e.target.value)}>
                        <option selected value="">Select Client</option>
                        {Clients.map((item, index) => <option value={item.us_code}>{item.us_code} : <strong>{item.us_name}</strong></option>)}


                      </select></div>
                      <div>
                        <FormControl
                          type="Date"
                          placeholder="Start Date"
                          value={startDateCurrent}
                          className="bg-light col-4"
                          onChange={(e) => setStartDateCurrent(e.target.value)}
                        />
                      </div>

                      <div>
                        <FormControl
                          type="Date"
                          placeholder=""
                          value={endDateCurrent}
                          className="bg-light col-4"
                          onChange={(e) => setEndDateCurrent(e.target.value)}
                        />
                      </div>

                      <div className="mb-3">
                        <input
                          type="text"
                          placeholder="Search by Table No..."
                          value={searchTableNumber}
                          onChange={(e) => {
                            const value = e.target.value;
                            // Allow only numeric input
                            if (/^\d*$/.test(value)) {
                              setSearchTableNumber(value);
                              setOrderFilter("tableSearch");
                            }
                          }}
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div
                      style={{
                        border: "1px solid #dddddd",
                        borderRadius: "10px",
                        overflowX: "auto", // Enable horizontal scrolling if the content overflows
                        padding: "0px", // Add padding for better spacing
                        maxWidth: "100%", // Ensure the div doesn't exceed the screen width
                        boxSizing: "border-box", // Prevents padding from affecting the width
                      }}
                    >
                      <table className="col-12" style={{ tableStyle }}>
                        <thead>
                          <tr style={{ borderBottom: "1px solid #ddd" }}>
                            <th
                              className="text-center col-1 p-3 single-line-css"
                              style={thTdStyle}
                            >
                              Client
                            </th>
                            <th
                              className="text-center col-1 p-3  single-line-css"
                              style={thTdStyle}
                            >
                              Order ID
                            </th>
                            <th
                              className="text-center col-1 p-3"
                              style={thTdStyle}
                            >
                              Date
                            </th>
                            <th
                              className="text-center col-1 p-3 single-line-css"
                              style={thTdStyle}
                            >
                              Time Elapsed
                            </th>
                            <th
                              className="text-center col-3 p-3 single-line-css"
                              style={thTdStyle}
                            >
                              Name & Mobile No.
                            </th>
                            {/* <th
                                                 className="text-center col-3 p-3 single-line-css"
                                                 style={thTdStyle}
                                               >
                                                 Mobile No.
                                               </th> */}
                            <th
                              className="text-center col-1 p-3 single-line-css"
                              style={thTdStyle}
                            >
                              Order Type
                            </th>
                            <th
                              className="text-center col-2 p-3"
                              style={thTdStyle}
                            >
                              Status
                            </th>

                            {/* Conditionally render the Action and Print headers based on orderFilter */}
                            {orderFilter !== "rejected" && (
                              <>
                                <th
                                  className="text-center col-4 p-3"
                                  style={thTdStyle}
                                >
                                  Action
                                </th>
                                <th
                                  className="text-center  p-3"
                                  style={thTdStyle}
                                >
                                  Print
                                </th>
                              </>
                            )}
                            {orderFilter === "rejected" && (
                              <>
                                <th
                                  className="text-center p-3"
                                  style={thTdStyle}
                                >
                                  Reason
                                </th>
                              </>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {orderAfterFilterPagination.length === 0 || newOrderLoader ? (
                            <tr>

                              <td colSpan="9" className="text-center py-3">

                                {orderAfterFilterPagination.length === 0 && !newOrderLoader ? <strong>No Orders Found !</strong> : ""}
                                {newOrderLoader ?
                                  <div className="m-5 p-5 d-flex justify-content-center">
                                    <div className="loader"></div>
                                  </div>

                                  : ""}
                              </td>
                            </tr>
                          ) : (

                            orderAfterFilterPagination
                              .slice()
                              .map((item, index) => {
                                const addressObj =
                                  JSON.parse(item.address_json)?.values || {};
                                const fullAddress = `
                           ${addressObj.address || ""}, 
                           ${addressObj.landmark_area || ""}, 
                           ${addressObj.building_name || ""}, 
                           ${addressObj.house_number || ""} 
                           ${addressObj.floor_number || ""} 
                           ${addressObj.city || ""}, 
                           ${addressObj.state || ""}, 
                           ${addressObj.in_pin_code || ""}
                         `.trim();
                                // const fullAddress =item.address_line;
                                // Calculate elapsed time
                                const { time: elapsedTime, status } =
                                  calculateElapsedTime(item.order_date);
                                return (
                                  <React.Fragment key={index}>
                                    <tr
                                      className={`table-row ${item.status === "received" ? "" : " "
                                        }`}
                                      style={{
                                        ...accordionToggleStyle,
                                        ...(openRowIndex_NewOrder === index
                                          ? openRowStyle
                                          : {}),
                                        borderBottom: "1px solid #ddd",
                                      }}
                                      onClick={() => toggleRow_NewOrder(index, item.orderid)}
                                    >
                                      <td
                                        className={`text-center align-middle text-order ${openRowIndex_NewOrder === index
                                          ? "text-dark"
                                          : "text-dark"
                                          }`}
                                        style={thTdStyle}
                                      >
                                        <b> {item.organization_name}</b>

                                      </td>
                                      <td
                                        className={`text-center align-middle text-order ${openRowIndex_NewOrder === index
                                          ? "text-dark"
                                          : "text-dark"
                                          }`}
                                        style={thTdStyle}
                                      >
                                        <strong>{item.daily_order_id}</strong>/
                                        <strong>{item.orderid}</strong>
                                      </td>
                                      <td
                                        className={`text-center align-middle text-order single-line-css ${openRowIndex_NewOrder === index
                                          ? "text-dark"
                                          : "text-dark"
                                          }`}
                                        style={thTdStyle}
                                      >
                                        {item.order_date && (
                                          <div>
                                            <div>
                                              {item.order_date.split(" ")[0]}
                                            </div>
                                            <div>
                                              {item.order_date
                                                .split(" ")[1]
                                                .slice(0, 5) +
                                                " " +
                                                item.order_date.split(" ")[2]}
                                            </div>
                                          </div>
                                        )}
                                      </td>
                                      <td
                                        className={`text-center align-middle text-order ${openRowIndex_NewOrder === index
                                          ? "text-dark"
                                          : "text-dark"
                                          }`}
                                        style={{
                                          position: "relative",
                                          overflow: "visible",
                                          thTdStyle,
                                        }}
                                      >
                                        <div className="d-flex justify-content-center align-items-center">
                                          {/* Elapsed Time Positioned to Extend Outside */}
                                          <div
                                            className="text-white p-1 px-2"
                                            style={{
                                              fontSize: "0.8rem",
                                              backgroundColor:
                                                item.status === "received" ||
                                                  item.status === "rejected" ||
                                                  item.status === "refunded"
                                                  ? "rgba(128, 128, 128, 1)"
                                                  : status === "overdue"
                                                    ? "rgba(255, 0, 0, 1)"
                                                    : "rgba(1, 195, 125, 1)",
                                              position: "absolute",
                                              // left: '0px',
                                              // transform: 'translate(-50%, -50%)',
                                              whiteSpace: "nowrap",
                                              // top: '50%',
                                              marginLeft: "0px",
                                              borderRadius: "5px",
                                            }}
                                          >
                                            {item.status === "received" ||
                                              item.status === "rejected" ||
                                              item.status === "refunded"
                                              ? "00:00"
                                              : elapsedTime}
                                          </div>
                                        </div>
                                      </td>
                                      <td
                                        className={`text-center align-middle text-order ${openRowIndex_NewOrder === index
                                          ? "text-dark"
                                          : "text-dark"
                                          }`}
                                        style={thTdStyle}
                                      >
                                        <div> {item.customer_name}</div>
                                        <div> {item.customer_mobile}</div>
                                      </td>
                                      <td
                                        className={`text-center align-middle text-order ${openRowIndex_NewOrder === index
                                          ? "text-dark"
                                          : "text-dark"
                                          }`}
                                        style={thTdStyle}
                                      >
                                        {(() => {
                                          switch (item.orderType) {
                                            case "home_delivery":
                                              return (
                                                <>
                                                  Home <br /> Delivery
                                                </>
                                              );
                                            case "takeway":
                                              return "Takeaway";
                                            case "dining":
                                              return "Dining";
                                            default:
                                              return (
                                                <>
                                                  Not <br /> Selected
                                                </>
                                              ); // Fallback for any Not Selecteds
                                          }
                                        })()}
                                      </td>
                                      <td
                                        className={`text-center align-middle text-order ${openRowIndex_Active === index
                                          ? "text-dark"
                                          : "text-dark"
                                          }`}
                                        style={thTdStyle}
                                      >
                                        <div className=" single-line-css">
                                          {item.status === "received" ? (
                                            <>
                                              <span
                                                className=" text-center text-primary w-100  px-3 py-1"
                                                style={{
                                                  width: "91px",
                                                  height: "31px",
                                                  borderRadius: "50px",

                                                  background:
                                                    "rgb(228, 235, 255)",
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                {item.orderType === "dining" ? (
                                                  <>
                                                    <span className="text-dark">
                                                      Table {item.table_no}{" "}
                                                      Active
                                                    </span>
                                                  </>
                                                ) : (
                                                  // <>Order Initiated</>
                                                  <>Waiting for Payment</>
                                                )}
                                              </span>
                                            </>
                                          ) : (
                                            <>
                                              {item.status === "paid" ||
                                                item.status === "Paid" ? (
                                                <div className="d-flex justify-content-center">
                                                  <div>
                                                    {item.delivery_partner_status ===
                                                      "food is ready" ? (
                                                      <span
                                                        className=" text-center w-100  px-3 py-1 text-dark bg-warning"
                                                        style={{
                                                          width: "91px",
                                                          height: "31px",
                                                          borderRadius: "50px",

                                                          fontWeight: "bold",
                                                        }}
                                                      >
                                                        Dispatched
                                                      </span>
                                                    ) : (
                                                      <span
                                                        className=" text-center w-100  px-3 py-1"
                                                        style={{
                                                          width: "91px",
                                                          height: "31px",
                                                          borderRadius: "50px",
                                                          color:
                                                            " rgba(1, 195, 125, 1)",
                                                          background:
                                                            " rgba(242, 252, 248, 1)",
                                                          fontWeight: "bold",
                                                        }}
                                                      >
                                                        {item.payment_mode.charAt(0).toUpperCase() + item.payment_mode.slice(1)} Paid & Preparing
                                                      </span>
                                                    )}
                                                  </div>
                                                </div>
                                              ) : item.status === "prepared" ? (
                                                <span
                                                  className=" text-center w-100  px-3 py-1"
                                                  style={{
                                                    width: "91px",
                                                    height: "31px",
                                                    borderRadius: "50px",
                                                    color:
                                                      " rgba(1, 195, 125, 1)",
                                                    background:
                                                      " rgba(242, 252, 248, 1)",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  Prepared
                                                </span>
                                              ) : (
                                                <span
                                                  className="text-center w-100 px-3 py-1"
                                                  style={{
                                                    width: "91px",
                                                    height: "31px",
                                                    borderRadius: "50px",
                                                    color:
                                                      item.status === "rejected"
                                                        ? "rgba(255, 0, 0, 1)" // Red for rejected
                                                        : item.status ===
                                                          "refunded"
                                                          ? "rgba(0, 128, 0, 1)" // Green for refunded
                                                          : "rgba(255, 72, 72, 1)", // Default color for not paid
                                                    background:
                                                      item.status === "rejected"
                                                        ? "rgba(255, 224, 224, 1)" // Light red background for rejected
                                                        : item.status ===
                                                          "refunded"
                                                          ? "rgba(224, 255, 224, 1)" // Light green background for refunded
                                                          : "rgba(255, 224, 224, 1)", // Default background for not paid
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  {item.status === "rejected" ||
                                                    item.status === "refunded" ? (
                                                    <>
                                                      {item.status
                                                        .charAt(0)
                                                        .toUpperCase() +
                                                        item.status.slice(1)}
                                                    </>
                                                  ) : (
                                                    <>Not Paid</>
                                                  )}
                                                </span>
                                              )}
                                            </>
                                          )}
                                        </div>
                                      </td>
                                      {/* Action Button */}
                                      <td
                                        className="d-flex text-center justify-content-center align-items-center align-middle"
                                        style={thTdStyle}
                                      >
                                        {item.status === "received" ? (
                                          <>
                                            <div className="d-flex justify-content-between align-items-center">

                                              <button
                                                className="btn btn btn-success single-line-css"
                                                onClick={() => {
                                                  setShowPaymentmodelModal(
                                                    true
                                                  );
                                                  setPaymentOrderId(
                                                    item.orderid
                                                  );
                                                  setTotalOrderAmount(item.totalOrderPrice);
                                                }}
                                              >
                                                Collect Cash
                                              </button>
                                            </div>


                                          </>
                                        ) : (
                                          <>
                                            {item.status === "paid" ||
                                              item.status === "Paid" ? (
                                              <div className="d-flex justify-content-center">
                                                {/* Dispatch Order - Active */}
                                                <button
                                                  type="button"
                                                  onClick={(e) => {
                                                    e.stopPropagation();

                                                    setShowModal(true);
                                                    setModalData(item); // Set item data for the modal
                                                    setFullAddressState(
                                                      fullAddress
                                                    ); // Set full address for modal
                                                  }}
                                                  // className="mx-2 my-2 btn bg-white btn-outline-primary text-primary"
                                                  className={`position-relative mx-2 my-2 btn ${item.delivery_partner_status ===
                                                    "acknowledged"
                                                    ? "bg-success text-white border-success "
                                                    : item.delivery_partner_status ===
                                                      "food is ready"
                                                      ? "bg-warning text-dark border-dark"
                                                      : "bg-white btn-outline-primary text-primary"
                                                    }`}
                                                  style={{
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  {item.delivery_partner_status ===
                                                    "food is ready"
                                                    ? "Dispatched"
                                                    : "Dispatch Order"}

                                                  {item.delivery_partner_status ===
                                                    "acknowledged" && (
                                                      <span
                                                        className="position-absolute top-0 start-50 translate-middle badge rounded-pill bg-warning text-dark"
                                                        style={{
                                                          fontSize: "0.65rem",
                                                          zIndex: 1, // ensure it’s on top
                                                          pointerEvents: "none", // prevent it from catching mouse events
                                                        }}
                                                      >
                                                        Assigned
                                                      </span>
                                                    )}
                                                  {item.delivery_partner_status ===
                                                    "food is ready" && (
                                                      <span
                                                        className="position-absolute top-0 start-50 translate-middle badge rounded-pill bg-success text-white"
                                                        style={{
                                                          fontSize: "0.65rem",
                                                          zIndex: 1, // ensure it’s on top
                                                          pointerEvents: "none", // prevent it from catching mouse events
                                                        }}
                                                      >
                                                        Processing
                                                      </span>
                                                    )}
                                                </button>
                                                <button
                                                  type="button"
                                                  className={`btn my-2 bg-red-light btn-outline-danger`}
                                                  style={openButtonStyle1}
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    rejectOrderAPI(
                                                      item.orderid,
                                                      item.us_code
                                                    );
                                                  }}
                                                >
                                                  Cancel
                                                </button>
                                              </div>
                                            ) : (
                                              <div className="d-flex justify-content-center">
                                                {item.status === "rejected" ||
                                                  item.status === "refunded" ? (
                                                  <span className="text-danger single-line-css px-3">
                                                    {item.remark || "NA"}
                                                  </span>
                                                ) : (
                                                  <>
                                                    {/* Dispatch Order - Disabled */}
                                                    <button
                                                      type="button"
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        setShowModal(true);
                                                        setModalData(item); // Set item data for the modal
                                                        setFullAddressState(
                                                          fullAddress
                                                        ); // Set full address for modal
                                                      }}
                                                      className="mx-2 my-2 btn bg-white btn-outline-gray text-gray"
                                                      style={{
                                                        whiteSpace: "nowrap",
                                                      }}
                                                      disabled
                                                    >
                                                      Dispatch Order
                                                    </button>
                                                    <button
                                                      type="button"
                                                      className={`btn my-2 bg-red-light btn-outline-danger`}
                                                      style={openButtonStyle1}
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        rejectOrderAPI(
                                                          item.orderid,
                                                          item.us_code
                                                        );
                                                      }}
                                                    >
                                                      Cancel
                                                    </button>
                                                  </>
                                                )}
                                              </div>
                                            )}
                                          </>
                                        )}
                                      </td>
                                      <td
                                        className="text-order "
                                        style={thTdStyle}
                                      >
                                        {item.status !== "rejected" &&
                                          item.status !== "refunded" && (
                                            <div className="d-flex justify-content-center px-3 gap-2">
                                              <button
                                                className="bg-white border border-parimary  text-primary"
                                                style={{
                                                  backgroundCcolor: "#fff",
                                                  borderRadius: "5px",
                                                  padding: "5px 10px",
                                                  color: "#fff",
                                                  cursor: "pointer",
                                                  transition:
                                                    "background-color 0.3s ease" /* Smooth hover transition */,
                                                }}
                                                // onClick={() =>
                                                //   handlePrint(
                                                //     reciptDetails,
                                                //     item,
                                                //     fullAddress
                                                //   )
                                                // }
                                                onClick={() => orderDetailesAPIForPrint(index, item.orderid, reciptDetails, fullAddress)}

                                                onMouseEnter={(e) =>
                                                (e.target.style.backgroundColor =
                                                  "#0056b3")
                                                }
                                                onMouseLeave={(e) =>
                                                (e.target.style.backgroundColor =
                                                  "#007BFF")
                                                }
                                              >
                                                Print
                                              </button>

                                              <>
                                                <button
                                                  className="bg-white border border-parimary  text-primary single-line-css"
                                                  style={{
                                                    backgroundCcolor: "#fff",
                                                    borderRadius: "5px",
                                                    padding: "5px 10px",
                                                    color: "#fff",
                                                    cursor: "pointer",
                                                    transition:
                                                      "background-color 0.3s ease"
                                                  }}

                                                  onClick={() =>
                                                    handlePrintNode(
                                                      item,
                                                      reciptDetails.business_name,
                                                      reciptDetails.gst,
                                                      reciptDetails.address,
                                                      reciptDetails.phone_no,
                                                      fullAddress,
                                                      printConfig.normalFontSize,
                                                      printConfig.largeFontSize,
                                                      printConfig.pageWidth
                                                    )
                                                  }

                                                  onMouseEnter={(e) =>
                                                  (e.target.style.backgroundColor =
                                                    "#0056b3")
                                                  }
                                                  onMouseLeave={(e) =>
                                                  (e.target.style.backgroundColor =
                                                    "#007BFF")
                                                  }
                                                >
                                                  Direct
                                                </button>
                                              </>



                                            </div>
                                          )}
                                      </td>
                                    </tr>


                                    {/* Conditional Rendering Section */}
                                    {openRowIndex_NewOrder === index && (
                                      (orderDetailesLoader ?

                                        <tr>
                                          <td colSpan="10" className="p-4 bg-light">
                                            <div className="row">

                                              {/* Left Section: Simulating Stepper or Info Block */}


                                              <div className="col-8">
                                                <div className="bg-white border rounded p-3 mb-3">
                                                  <div className="text-muted mb-2 fs-5 text-center"><strong>Loading...</strong> </div>
                                                  <div className="row mb-1">
                                                    <div className="col-3 bg-light p-2 rounded">&nbsp;</div>
                                                    <div className="col-5 bg-light p-2 rounded ms-2">&nbsp;</div>
                                                    <div className="col-2 bg-light p-2 rounded ms-2">&nbsp;</div>
                                                  </div>
                                                  <div className="row mb-1">
                                                    <div className="col-3 bg-light p-2 rounded">&nbsp;</div>
                                                    <div className="col-5 bg-light p-2 rounded ms-2">&nbsp;</div>
                                                    <div className="col-2 bg-light p-2 rounded ms-2">&nbsp;</div>
                                                  </div>
                                                  <div className="text-muted mt-3"></div>
                                                </div>
                                              </div>
                                              {/* Right Section: Simulating Order Items Table */}

                                              <div className="col-4">
                                                <div className="bg-white border rounded p-3 mb-3" style={{ height: "150px" }}>
                                                  <div className="text-muted text-center"></div>
                                                </div>
                                                <div className="bg-white border rounded p-3" style={{ height: "100px" }}>
                                                  <div className="text-muted text-center"></div>
                                                </div>
                                              </div>

                                            </div>
                                          </td>
                                        </tr>

                                        :

                                        <>
                                          <tr className="">
                                            <td colSpan="10" className="p-0 m-0">
                                              <div
                                                className="row col-12 m-0 p-3"
                                                style={{
                                                  backgroundColor: "#ddd",
                                                  display: "flex",
                                                  borderBottom: "1px solid #ddd",
                                                  borderLeft: "1px solid #ddd",
                                                  borderRight: "1px solid #ddd",
                                                  borderRadius: "0px 0px 10px 10px",
                                                }}
                                              >
                                                {item.status !== "rejected" && (
                                                  <StepperComponent
                                                    status={particularOrderDetails.status}
                                                    organizationDetails={
                                                      organizationDetails
                                                    }
                                                    reciptDetails={reciptDetails}
                                                    item={particularOrderDetails}
                                                    fullAddress={fullAddress}
                                                    handleKitchenPrint={
                                                      handleKitchenPrint
                                                    }
                                                  />
                                                )}

                                                <div className="col-8 m-0 p-0 pt-3 ">
                                                  <div
                                                    className="bg-white border-15-only  p-4"
                                                    ref={(el) =>
                                                    (contentRefsCol5.current[
                                                      index
                                                    ] = el)
                                                    }
                                                    style={{
                                                      ...accordionContentStyle,
                                                      height: `${contentRefsCol5.current[index]?.scrollHeight}px`,
                                                      borderRadius: "12px",
                                                    }}
                                                  >
                                                    <div className="container px-0">
                                                      <table className="table table-border p-0">
                                                        <thead className="">
                                                          <tr>
                                                            <th
                                                              scope="col"
                                                              className="text-start text-bold pb-2 text-secondary p-0 m-0"
                                                            >
                                                              S.No.
                                                            </th>
                                                            <th
                                                              scope="col"
                                                              className="text-start text-secondary pb-2  p-0 m-0"
                                                            >
                                                              Item Name
                                                            </th>
                                                            <th
                                                              scope="col"
                                                              className="text-center text-secondary pb-2  p-0 m-0"
                                                            >
                                                              Quantity
                                                            </th>
                                                            <th
                                                              scope="col"
                                                              className="text-end text-secondary pb-2  p-0 m-0"
                                                            >
                                                              Unit Price
                                                            </th>
                                                            <th
                                                              scope="col"
                                                              className="text-end text-secondary pb-2  p-0 m-0"
                                                            >
                                                              Price
                                                            </th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          {particularOrderDetails.items?.map(
                                                            (subitem, subindex) => {
                                                              const orderKey = `printedOrders_${item.orderid}`;
                                                              const printedItemsForOrder =
                                                                JSON.parse(
                                                                  localStorage.getItem(
                                                                    orderKey
                                                                  )
                                                                ) || [];
                                                              const isPrinted =
                                                                printedItemsForOrder.includes(
                                                                  subitem.id
                                                                );

                                                              return (
                                                                <tr
                                                                  key={subindex}
                                                                  className="align-middle"
                                                                >
                                                                  <td className="text-start py-2 p-0 m-0 ">
                                                                    {subindex + 1}
                                                                  </td>
                                                                  <td className="text-start py-2 p-0 m-0">
                                                                    <span className="fw-semibold">
                                                                      {
                                                                        subitem.product_id
                                                                      }
                                                                    </span>
                                                                    <span
                                                                      className={`ms-2 rounded-pill small ${isPrinted
                                                                        ? "bg-light text-primary badge border border-primary"
                                                                        : "bg-success text-white badge"
                                                                        }`}
                                                                    >
                                                                      {isPrinted
                                                                        ? "Printed"
                                                                        : "New"}
                                                                    </span>
                                                                    {subitem.customization &&
                                                                      subitem.customization !==
                                                                      "{}" && (
                                                                        <div className="text-muted small">
                                                                          (
                                                                          {(() => {
                                                                            try {
                                                                              const customization =
                                                                                JSON.parse(
                                                                                  subitem.customization
                                                                                );
                                                                              return Object.entries(
                                                                                customization
                                                                              )
                                                                                .map(
                                                                                  ([
                                                                                    key,
                                                                                    value,
                                                                                  ]) => {
                                                                                    if (
                                                                                      Array.isArray(
                                                                                        value
                                                                                      )
                                                                                    ) {
                                                                                      return `${key}: ${value.join(
                                                                                        ", "
                                                                                      )}`;
                                                                                    } else {
                                                                                      return `${key}: ${value}`;
                                                                                    }
                                                                                  }
                                                                                )
                                                                                .join(
                                                                                  " | "
                                                                                );
                                                                            } catch (e) {
                                                                              return "Customization info not readable";
                                                                            }
                                                                          })()}
                                                                          )
                                                                        </div>
                                                                      )}
                                                                  </td>
                                                                  <td className="text-center py-2 p-0 m-0 fw-semibold">
                                                                    {
                                                                      subitem.quantity
                                                                    }
                                                                  </td>
                                                                  <td className="text-end py-2 p-0 m-0">
                                                                    ₹{" "}
                                                                    {
                                                                      subitem.item_price
                                                                    }
                                                                  </td>
                                                                  <td className="text-end py-2 p-0 m-0">
                                                                    ₹{" "}
                                                                    {
                                                                      subitem.total_price
                                                                    }
                                                                  </td>
                                                                </tr>
                                                              );
                                                            }
                                                          )}
                                                        </tbody>
                                                      </table>

                                                      {/* Sub Total */}
                                                      <div className="d-flex justify-content-between ">
                                                        <div className="text-muted">
                                                          Sub Total{" "}
                                                          {particularOrderDetails.gst_claim !==
                                                            "Y" ? (
                                                            <span>(Tax Inc.)</span>
                                                          ) : (
                                                            ""
                                                          )}
                                                        </div>
                                                        <div className="text-muted">
                                                          ₹ {particularOrderDetails.subtotal}
                                                        </div>
                                                      </div>

                                                      {/* Discount */}
                                                      {particularOrderDetails.discount_amount !==
                                                        "0.00" && (
                                                          <div className="d-flex justify-content-between ">
                                                            <div className="text-muted">
                                                              Discount (
                                                              {Math.round(
                                                                particularOrderDetails.discount_percentage
                                                              )}
                                                              %)
                                                            </div>
                                                            <div className="text-muted ">
                                                              - ₹{" "}
                                                              {particularOrderDetails.discount_amount}
                                                            </div>
                                                          </div>
                                                        )}
                                                      {particularOrderDetails.coupon_applied && (
                                                        <>
                                                          <div className="d-flex justify-content-between ">
                                                            <div className="text-muted">
                                                              Coupon Code Discount
                                                            </div>
                                                            <div className="text-muted">
                                                              ₹{" "}
                                                              {Number(
                                                                particularOrderDetails.coupon_code_discount
                                                              ).toFixed(2)}
                                                            </div>
                                                          </div>
                                                        </>
                                                      )}
                                                      {particularOrderDetails.loyalty_points_discount !== "0.000000" && (
                                                        <>
                                                          <div className="d-flex justify-content-between ">
                                                            <div className="text-muted">
                                                              Loyalty Points Discount
                                                            </div>
                                                            <div className="text-muted">
                                                              ₹{" "}
                                                              {Number(
                                                                particularOrderDetails.loyalty_points_discount
                                                              ).toFixed(2)}
                                                            </div>
                                                          </div>
                                                        </>
                                                      )}
                                                      {particularOrderDetails.gst_claim === "Y" && (
                                                        <>
                                                          <div className="d-flex justify-content-between ">
                                                            <div className="text-muted">
                                                              CGST
                                                            </div>
                                                            <div className="text-muted">
                                                              ₹{" "}
                                                              {Number(
                                                                particularOrderDetails.tax_cgst
                                                              ).toFixed(2)}
                                                            </div>
                                                          </div>

                                                          <div className="d-flex justify-content-between ">
                                                            <div className="text-muted">
                                                              SGST
                                                            </div>
                                                            <div className="text-muted">
                                                              ₹{" "}
                                                              {Number(
                                                                particularOrderDetails.tax_sgst
                                                              ).toFixed(2)}
                                                            </div>
                                                          </div>
                                                        </>
                                                      )}

                                                      {/* Delivery Fee */}
                                                      <div className="d-flex justify-content-between ">
                                                        <div className="text-muted">
                                                          Delivery Fee
                                                        </div>
                                                        <div className="text-muted">
                                                          + ₹ {particularOrderDetails.delivery_fee}
                                                        </div>
                                                      </div>
                                                      <hr className="m-0 p-0 my-2" />
                                                      {/* Total */}
                                                      <div className="d-flex justify-content-between p-0 m-0">
                                                        <div className="fw-bold text-primary h6 m-0">
                                                          Total Price
                                                        </div>
                                                        <div className="fw-bold text-primary h6 m-0">
                                                          ₹ {particularOrderDetails.totalOrderPrice}
                                                        </div>
                                                      </div>


                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="col-4 m-0 p-0 pt-3">
                                                  <div
                                                    className="bg-white border-15-only p-4 ms-3 d-flex flex-column justify-content-center align-items-center"
                                                    ref={(el) =>
                                                    (contentRefsCol1.current[
                                                      index
                                                    ] = el)
                                                    }
                                                    style={{
                                                      ...accordionContentStyle,
                                                      height: `${contentRefsCol1.current[index]?.scrollHeight}px`,
                                                      borderRadius: "12px",
                                                      minWidth: "250px",
                                                      maxWidth: "100%",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    {particularOrderDetails.orderType === "dining" ? (
                                                      <>
                                                        <div className="text-muted fs-6 mb-2">
                                                          Dining Order
                                                        </div>
                                                        <div className="fs-4 fw-bold text-dark">
                                                          Table No. {particularOrderDetails.table_no}
                                                        </div>
                                                      </>
                                                    ) : (
                                                      <>
                                                        <div className="text-bold fs-6 mb-2">
                                                          Delivery Address
                                                        </div>
                                                        <div className="fs-6 text-bold text-secondary mb-1">
                                                          {particularOrderDetails.table_no}
                                                        </div>
                                                        <div className="text-5 text-dark fw-semibold">
                                                          {fullAddress &&
                                                            fullAddress
                                                              .trim()
                                                              .replace(/,+/g, "")
                                                              .replace(/\s+/g, "")
                                                              .length > 0 ? (
                                                            <span
                                                              style={{
                                                                whiteSpace:
                                                                  "normal",
                                                              }}
                                                            >
                                                              {fullAddress}
                                                            </span>
                                                          ) : (
                                                            <span className="text-danger">
                                                              Address not found
                                                            </span>
                                                          )}
                                                        </div>
                                                      </>
                                                    )}
                                                  </div>

                                                  {/* Platform Charges Breakdown */}
                                                  <div
                                                    style={{
                                                      borderRadius: "12px",
                                                    }}
                                                    className="bg-white mt-3 border-15-only p-4 ms-3 d-flex flex-column justify-content-center align-items-center-4 p-4 bg-light rounded-3  "
                                                  >
                                                    <h6 className="text-primary mb-3 fw-bold">
                                                      Platform Charges
                                                    </h6>

                                                    <div className="d-flex justify-content-between">
                                                      <span className="text-muted">
                                                        Messages Sent
                                                      </span>
                                                      <span className="text-muted">
                                                        {particularOrderDetails.message_count || 1}{" "}
                                                        Message(s)
                                                      </span>
                                                    </div>

                                                    <div className="d-flex justify-content-between">
                                                      <span className="text-muted">
                                                        Per Message Cost
                                                      </span>
                                                      <span className="text-muted">
                                                        ₹{" "}
                                                        {Number(
                                                          particularOrderDetails.per_message_cost
                                                        ).toFixed(2)}
                                                      </span>
                                                    </div>

                                                    <div className="d-flex justify-content-between">
                                                      <span className="text-muted">
                                                        Message Charges
                                                      </span>
                                                      <span className="text-muted">
                                                        ₹{" "}
                                                        {(particularOrderDetails.message_count || 1) *
                                                          Number(
                                                            particularOrderDetails.per_message_cost ||
                                                            0
                                                          ).toFixed(2)}
                                                      </span>
                                                    </div>

                                                    <div className="d-flex justify-content-between">
                                                      <span className="text-muted">
                                                        GST on Message Charges
                                                      </span>
                                                      <span className="text-muted">
                                                        ₹{" "}
                                                        {Number(
                                                          particularOrderDetails.message_charges_tax_gst ||
                                                          0
                                                        ).toFixed(2)}
                                                      </span>
                                                    </div>

                                                    <hr className="my-2" />

                                                    <div className="d-flex justify-content-between">
                                                      <strong className="text-dark">
                                                        Total Platform Fee
                                                      </strong>
                                                      <strong className="text-dark">
                                                        ₹{" "}
                                                        {(
                                                          (particularOrderDetails.message_count ||
                                                            1) *
                                                          Number(
                                                            particularOrderDetails.per_message_cost ||
                                                            0
                                                          ) +
                                                          Number(
                                                            particularOrderDetails.message_charges_tax_gst ||
                                                            0
                                                          )
                                                        ).toFixed(2)}
                                                      </strong>
                                                    </div>
                                                  </div>
                                                </div>









                                              </div>
                                            </td>
                                          </tr>
                                        </>

                                      )
                                    )}
                                  </React.Fragment>
                                );
                              })
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div className="py-3">
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onNextPage={handleNextPage}
                        onPrevPage={handlePrevPage}
                        onPageClick={handlePageClick}
                      />
                    </div>
                  </div>

                  {/* Order History */}
                  <div
                    className="tab-pane fade"
                    id="order-history-tab-pane"
                    role="tabpanel"
                    aria-labelledby="order-history-tab"
                  >
                    <div className="row col-12 p-0 d-flex justify-content-between my-2">
                      <div className="col-2"><select class="form-select" aria-label="Small select example" onChange={(e) => setuserID(e.target.value)}>
                        <option selected value="">Select Client</option>
                        {Clients.map((item, index) => <option value={item.us_code}>{item.us_code} : <strong>{item.us_name}</strong></option>)}


                      </select></div>
                      <div className="col-3 pe-2">
                        <FormControl
                          type="text"
                          placeholder="Search"
                          value={searchQuery}
                          className="bg-light "
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                      </div>
                      <div className="col-2 pe-2">
                        <FormControl
                          type="date"
                          placeholder="Start Date"
                          value={startDate}
                          className="bg-light col-4"
                          onFocus={(e) => e.target.showPicker()} // Trigger the picker on focus
                          onChange={(e) => setStartDate(e.target.value)}
                          onInput={(e) => e.preventDefault()} // Prevent manual typing
                        />
                      </div>

                      <div className="col-2 pe-2">
                        <FormControl
                          type="date"
                          placeholder="End Date"
                          value={endDate}
                          className="bg-light col-4"
                          onFocus={(e) => e.target.showPicker()} // Trigger the picker on focus
                          onChange={(e) => setEndDate(e.target.value)}
                          onInput={(e) => e.preventDefault()} // Prevent manual typing
                        />
                      </div>
                      <div className="col-1 pe-2 ">
                        <div
                          className="btn bg-green-filter text-white w-100"
                          onClick={(e) => {
                            OrderHistoryAPI();
                          }}
                        >
                          Search
                        </div>
                      </div>
                      <div className="col-2">
                        <button
                          className="blue-button w-100"
                          onClick={() => {
                            if (summaryData.length === 0) {
                              // Check if summaryData is empty
                              Swal.fire({
                                icon: "info", // Show 'info' icon
                                title: "No Data Found",
                                text: "No data found for the selected dates. Please try again with different dates.",
                                confirmButtonText: "OK",
                              });
                            } else {
                              handleDownload();
                            }
                          }}
                        >
                          Download Excel
                        </button>
                      </div>
                      <div className="col-2">
                        <button
                          className="blue-button w-100"
                          onClick={() => {
                            if (summaryData.length === 0) {
                              // Check if summaryData is empty
                              Swal.fire({
                                icon: "info", // Show 'info' icon
                                title: "No Data Found",
                                text: "No data found for the selected dates. Please try again with different dates.",
                                confirmButtonText: "OK",
                              });
                            } else {
                              printReceiptSUMMARY(
                                summaryData,
                                reciptDetails,
                                startDate,
                                endDate,
                                totalDeliveryCharges
                              );
                            }
                          }}
                        >
                          Summary Report
                        </button>
                      </div>
                    </div>
                    <div
                      style={{
                        border: "1px solid #dddddd",
                        borderRadius: "10px",
                        overflowX: "auto",
                        padding: "0px",
                        maxWidth: "100%",
                        boxSizing: "border-box",
                      }}
                    >
                      <table className="col-12 " style={tableStyle}>
                        <thead>
                          <tr style={{ borderBottom: "1px solid #ddd" }}>
                            <th
                              className="text-center col-1 p-3"
                              style={thTdStyle}
                            >
                              Client
                            </th>
                            <th
                              className="text-center col-1 p-3"
                              style={thTdStyle}
                            >
                              Sr. no
                            </th>
                            <th
                              className="text-center col-1 p-3"
                              style={thTdStyle}
                            >
                              Date
                            </th>
                            <th
                              className="text-center col-1 p-3"
                              style={thTdStyle}
                            >
                              Order ID
                            </th>
                            <th
                              className="text-center col-2 p-3"
                              style={thTdStyle}
                            >
                              Name
                            </th>
                            <th
                              className="text-center col-2 p-3"
                              style={thTdStyle}
                            >
                              Mobile Number
                            </th>
                            <th
                              className="text-center col-2 p-3"
                              style={thTdStyle}
                            >
                              Order Type
                            </th>
                            <th
                              className="text-center col-2 p-3"
                              style={thTdStyle}
                            >
                              Payment Mode
                            </th>
                            <th className="text-center p-3" style={thTdStyle}>
                              Status
                            </th>

                            <th className="text-center p-3 " style={thTdStyle}>
                              Print
                            </th>

                            <th
                              className="text-center p-3 text-white"
                              style={thTdStyle}
                            >
                              Open
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {orderHistoryPagination.length === 0 || completeOrderLoader ? (
                            <tr>
                              <td colSpan="9" className="text-center py-3">

                                {orderHistoryPagination.length === 0 && !completeOrderLoader ? <strong>No Orders Found !</strong> : ""}
                                {completeOrderLoader ?
                                  <div className="m-5 p-5 d-flex justify-content-center">
                                    <div className="loader"></div>
                                  </div>

                                  : ""}
                              </td>
                            </tr>
                          ) : (
                            orderHistoryPagination.map((item, index) => {
                              const addressObj =
                                JSON.parse(item.address_json)?.values || {};
                              const fullAddress = `
                                ${addressObj.address || ""}, 
                                ${addressObj.landmark_area || ""}, 
                                ${addressObj.building_name || ""}, 
                                ${addressObj.house_number || ""} 
                                ${addressObj.floor_number || ""} 
                                ${addressObj.city || ""}, 
                                ${addressObj.state || ""}, 
                                ${addressObj.in_pin_code || ""}
                              `.trim();
                              // const fullAddress =item.address_line;
                              return (
                                <React.Fragment key={index}>
                                  <tr
                                    style={{
                                      ...accordionToggleStyle,
                                      ...(openRowIndex_History === index
                                        ? openRowStyle
                                        : {}),
                                      borderBottom: "1px solid #ddd",
                                    }}
                                    onClick={() => toggleRow_History(index, item.orderid)}
                                  >
                                    <td
                                      className={`text-center align-middle text-order ${openRowIndex_History === index
                                        ? "text-dark"
                                        : "text-dark"
                                        }`}
                                      style={thTdStyle}
                                    >
                                      <b>{item.organization_name}</b>
                                    </td>
                                    <td
                                      className={`text-center align-middle text-order ${openRowIndex_History === index
                                        ? "text-dark"
                                        : "text-dark"
                                        }`}
                                      style={thTdStyle}
                                    >
                                      {index + startIndex + 1}
                                    </td>
                                    <td
                                      className={`text-center align-middle text-order single-line-css ${openRowIndex_NewOrder === index
                                        ? "text-dark"
                                        : "text-dark"
                                        }`}
                                      style={thTdStyle}
                                    >
                                      {item.order_date && (
                                        <div>
                                          <div>
                                            {item.order_date.split(" ")[0]}
                                          </div>
                                          <div>
                                            {item.order_date
                                              .split(" ")[1]
                                              .slice(0, 5) +
                                              " " +
                                              item.order_date.split(" ")[2]}
                                          </div>
                                        </div>
                                      )}
                                    </td>
                                    <td
                                      className={`text-center align-middle text-order ${openRowIndex_History === index
                                        ? "text-dark"
                                        : "text-dark"
                                        }`}
                                      style={thTdStyle}
                                    >
                                      <strong>
                                        {item.daily_order_id}/{item.orderid}{" "}
                                      </strong>
                                    </td>
                                    <td
                                      className={`text-center align-middle text-order ${openRowIndex_History === index
                                        ? "text-dark"
                                        : "text-dark"
                                        }`}
                                      style={thTdStyle}
                                    >
                                      {item.customer_name}
                                    </td>
                                    <td
                                      className={`text-center align-middle text-order ${openRowIndex_History === index
                                        ? "text-dark"
                                        : "text-dark"
                                        }`}
                                      style={thTdStyle}
                                    >
                                      {item.customer_mobile}
                                    </td>
                                    <td
                                      className={`text-center align-middle text-order ${openRowIndex_NewOrder === index
                                        ? "text-dark"
                                        : "text-dark"
                                        }`}
                                      style={thTdStyle}
                                    >
                                      {(() => {
                                        switch (item.orderType) {
                                          case "home_delivery":
                                            return (
                                              <>
                                                Home <br /> Delivery
                                              </>
                                            );
                                          case "takeway":
                                            return "Takeaway";
                                          case "dining":
                                            return "Dining";
                                          default:
                                            return (
                                              <>
                                                Not <br /> Selected
                                              </>
                                            ); // Fallback for any Not Selecteds
                                        }
                                      })()}
                                    </td>
                                    <td
                                      className={`text-center align-middle text-order ${openRowIndex_History === index
                                        ? "text-dark"
                                        : "text-dark"
                                        }`}
                                      style={thTdStyle}
                                    >
                                      {item.payment_mode.toUpperCase()}
                                    </td>
                                    <td
                                      className="text-center align-middle text-order "
                                      style={thTdStyle}
                                    >
                                      <StatusSpan item={item} />
                                    </td>
                                    <td
                                      className="text-order "
                                      style={thTdStyle}
                                    >
                                      <div className="d-flex justify-content-center px-3 gap-3">
                                        <button
                                          className="btn btn-primary blue-button"
                                          style={{
                                            backgroundColor:
                                              "#007BFF" /* Professional blue color */,
                                            border: "none",
                                            borderRadius: "5px",
                                            padding:
                                              "5px 10px" /* Adjust padding for better appearance */,
                                            color:
                                              "#fff" /* White text for contrast */,
                                            cursor: "pointer",
                                            transition:
                                              "background-color 0.3s ease" /* Smooth hover transition */,
                                          }}
                                          // onClick={() =>
                                          //   handlePrint(
                                          //     reciptDetails,
                                          //     item,
                                          //     fullAddress
                                          //   )
                                          // }
                                          onClick={() => orderDetailesAPIForPrint(index, item.orderid, reciptDetails, fullAddress)}
                                          onMouseEnter={(e) =>
                                          (e.target.style.backgroundColor =
                                            "#0056b3")
                                          } /* Darker shade on hover */
                                          onMouseLeave={(e) =>
                                          (e.target.style.backgroundColor =
                                            "#007BFF")
                                          } /* Restore original color */
                                        >
                                          Print
                                        </button>

                                        <>
                                          <button
                                            className="bg-white border border-parimary  text-primary single-line-css"
                                            style={{
                                              backgroundCcolor: "#fff",
                                              borderRadius: "5px",
                                              padding: "5px 10px",
                                              color: "#fff",
                                              cursor: "pointer",
                                              transition:
                                                "background-color 0.3s ease"
                                            }}

                                            onClick={() =>
                                              handlePrintNode(
                                                item,
                                                reciptDetails.business_name,
                                                reciptDetails.gst,
                                                reciptDetails.address,
                                                reciptDetails.phone_no,
                                                fullAddress,
                                                printConfig.normalFontSize,
                                                printConfig.largeFontSize,
                                                printConfig.pageWidth
                                              )
                                            }

                                            onMouseEnter={(e) =>
                                            (e.target.style.backgroundColor =
                                              "#0056b3")
                                            }
                                            onMouseLeave={(e) =>
                                            (e.target.style.backgroundColor =
                                              "#007BFF")
                                            }
                                          >
                                            Direct
                                          </button>
                                        </>


                                      </div>
                                    </td>

                                    <td
                                      className="text-order "
                                      style={thTdStyle}
                                    >
                                      <div className="d-flex justify-content-center">
                                        <button
                                          type="button"
                                          className="buttonOrder p-0"
                                        >
                                          <img src={down} alt="logo" />
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                  {openRowIndex_History === index && (

                                    (orderDetailesLoader ?

                                      <tr>
                                        <td colSpan="10" className="p-4 bg-light">
                                          <div className="row">

                                            {/* Left Section: Simulating Stepper or Info Block */}


                                            <div className="col-8">
                                              <div className="bg-white border rounded p-3 mb-3">
                                                <div className="text-muted mb-2 fs-5 text-center"><strong>Loading...</strong> </div>
                                                <div className="row mb-1">
                                                  <div className="col-3 bg-light p-2 rounded">&nbsp;</div>
                                                  <div className="col-5 bg-light p-2 rounded ms-2">&nbsp;</div>
                                                  <div className="col-2 bg-light p-2 rounded ms-2">&nbsp;</div>
                                                </div>
                                                <div className="row mb-1">
                                                  <div className="col-3 bg-light p-2 rounded">&nbsp;</div>
                                                  <div className="col-5 bg-light p-2 rounded ms-2">&nbsp;</div>
                                                  <div className="col-2 bg-light p-2 rounded ms-2">&nbsp;</div>
                                                </div>
                                                <div className="text-muted mt-3"></div>
                                              </div>
                                            </div>
                                            {/* Right Section: Simulating Order Items Table */}

                                            <div className="col-4">
                                              <div className="bg-white border rounded p-3 mb-3" style={{ height: "150px" }}>
                                                <div className="text-muted text-center"></div>
                                              </div>
                                              <div className="bg-white border rounded p-3" style={{ height: "100px" }}>
                                                <div className="text-muted text-center"></div>
                                              </div>
                                            </div>

                                          </div>
                                        </td>
                                      </tr>

                                      :

                                      <>



                                        <tr>
                                          <td colSpan="10" className="p-0 m-0">
                                            <div
                                              className="row col-12 m-0 p-3"
                                              style={{
                                                backgroundColor: "#ddd",
                                                display: "flex",
                                                borderBottom: "1px solid #ddd",
                                                borderLeft: "1px solid #ddd",
                                                borderRight: "1px solid #ddd",
                                                borderRadius: "0px 0px 10px 10px",
                                              }}
                                            >
                                              <StepperComponent
                                                status={item.status}
                                                item={item}
                                                fullAddress={fullAddress}
                                                organizationDetails={
                                                  organizationDetails
                                                }
                                                reciptDetails={reciptDetails}
                                                markCompletedForcefullyApi={
                                                  markCompletedForcefullyApi
                                                }
                                                handleKitchenPrint={
                                                  handleKitchenPrint
                                                }
                                              />
                                              <div className="row col-12 p-0 m-0 ">
                                                <div className="col-12 p-0 m-0 ">
                                                  <div className="  bg-white p-4  border-15-only mt-3  order-table-delivery-height">
                                                    <h3 className="text-3-2-dark">
                                                      Delivery Partner Details
                                                    </h3>
                                                    <div className="text-gray-700">
                                                      <p className="mb-1">
                                                        <strong>Name:</strong>{" "}
                                                        {item.delivery_person_name}
                                                      </p>
                                                      <p className="mb-1">
                                                        <strong>Contact:</strong>{" "}
                                                        {
                                                          item.delivery_person_number
                                                        }
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div>

                                              </div>

                                              <div className="col-8 m-0 p-0 pt-3 ">
                                                <div
                                                  className="bg-white border-15-only  p-4"
                                                  ref={(el) =>
                                                  (contentRefsCol5.current[
                                                    index
                                                  ] = el)
                                                  }
                                                  style={{
                                                    ...accordionContentStyle,
                                                    height: `${contentRefsCol5.current[index]?.scrollHeight}px`,
                                                    borderRadius: "12px",
                                                  }}
                                                >
                                                  <div className="container px-0">
                                                    <table className="table table-border p-0">
                                                      <thead className="">
                                                        <tr>
                                                          <th
                                                            scope="col"
                                                            className="text-start text-bold pb-2 text-secondary p-0 m-0"
                                                          >
                                                            S.No.
                                                          </th>
                                                          <th
                                                            scope="col"
                                                            className="text-start text-secondary pb-2  p-0 m-0"
                                                          >
                                                            Item Name
                                                          </th>
                                                          <th
                                                            scope="col"
                                                            className="text-center text-secondary pb-2  p-0 m-0"
                                                          >
                                                            Quantity
                                                          </th>
                                                          <th
                                                            scope="col"
                                                            className="text-end text-secondary pb-2  p-0 m-0"
                                                          >
                                                            Unit Price
                                                          </th>
                                                          <th
                                                            scope="col"
                                                            className="text-end text-secondary pb-2  p-0 m-0"
                                                          >
                                                            Price
                                                          </th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        {particularOrderDetails.items?.map(
                                                          (subitem, subindex) => {
                                                            const orderKey = `printedOrders_${item.orderid}`;
                                                            const printedItemsForOrder =
                                                              JSON.parse(
                                                                localStorage.getItem(
                                                                  orderKey
                                                                )
                                                              ) || [];
                                                            const isPrinted =
                                                              printedItemsForOrder.includes(
                                                                subitem.id
                                                              );

                                                            return (
                                                              <tr
                                                                key={subindex}
                                                                className="align-middle"
                                                              >
                                                                <td className="text-start py-2 p-0 m-0 ">
                                                                  {subindex + 1}
                                                                </td>
                                                                <td className="text-start py-2 p-0 m-0">
                                                                  <span className="fw-semibold">
                                                                    {
                                                                      subitem.product_id
                                                                    }
                                                                  </span>
                                                                  <span
                                                                    className={`ms-2 rounded-pill small ${isPrinted
                                                                      ? "bg-light text-primary badge border border-primary"
                                                                      : "bg-success text-white badge"
                                                                      }`}
                                                                  >
                                                                    {isPrinted
                                                                      ? "Printed"
                                                                      : "New"}
                                                                  </span>
                                                                  {subitem.customization &&
                                                                    subitem.customization !==
                                                                    "{}" && (
                                                                      <div className="text-muted small">
                                                                        (
                                                                        {(() => {
                                                                          try {
                                                                            const customization =
                                                                              JSON.parse(
                                                                                subitem.customization
                                                                              );
                                                                            return Object.entries(
                                                                              customization
                                                                            )
                                                                              .map(
                                                                                ([
                                                                                  key,
                                                                                  value,
                                                                                ]) => {
                                                                                  if (
                                                                                    Array.isArray(
                                                                                      value
                                                                                    )
                                                                                  ) {
                                                                                    return `${key}: ${value.join(
                                                                                      ", "
                                                                                    )}`;
                                                                                  } else {
                                                                                    return `${key}: ${value}`;
                                                                                  }
                                                                                }
                                                                              )
                                                                              .join(
                                                                                " | "
                                                                              );
                                                                          } catch (e) {
                                                                            return "Customization info not readable";
                                                                          }
                                                                        })()}
                                                                        )
                                                                      </div>
                                                                    )}
                                                                </td>
                                                                <td className="text-center py-2 p-0 m-0 fw-semibold">
                                                                  {
                                                                    subitem.quantity
                                                                  }
                                                                </td>
                                                                <td className="text-end py-2 p-0 m-0">
                                                                  ₹{" "}
                                                                  {
                                                                    subitem.item_price
                                                                  }
                                                                </td>
                                                                <td className="text-end py-2 p-0 m-0">
                                                                  ₹{" "}
                                                                  {
                                                                    subitem.total_price
                                                                  }
                                                                </td>
                                                              </tr>
                                                            );
                                                          }
                                                        )}
                                                      </tbody>
                                                    </table>

                                                    {/* Sub Total */}
                                                    <div className="d-flex justify-content-between ">
                                                      <div className="text-muted">
                                                        Sub Total{" "}
                                                        {particularOrderDetails.gst_claim !==
                                                          "Y" ? (
                                                          <span>(Tax Inc.)</span>
                                                        ) : (
                                                          ""
                                                        )}
                                                      </div>
                                                      <div className="text-muted">
                                                        ₹ {particularOrderDetails.subtotal}
                                                      </div>
                                                    </div>

                                                    {/* Discount */}
                                                    {particularOrderDetails.discount_amount !==
                                                      "0.00" && (
                                                        <div className="d-flex justify-content-between ">
                                                          <div className="text-muted">
                                                            Discount (
                                                            {Math.round(
                                                              particularOrderDetails.discount_percentage
                                                            )}
                                                            %)
                                                          </div>
                                                          <div className="text-muted ">
                                                            - ₹{" "}
                                                            {particularOrderDetails.discount_amount}
                                                          </div>
                                                        </div>
                                                      )}
                                                    {particularOrderDetails.coupon_applied && (
                                                      <>
                                                        <div className="d-flex justify-content-between ">
                                                          <div className="text-muted">
                                                            Coupon Code Discount
                                                          </div>
                                                          <div className="text-muted">
                                                            ₹{" "}
                                                            {Number(
                                                              particularOrderDetails.coupon_code_discount
                                                            ).toFixed(2)}
                                                          </div>
                                                        </div>
                                                      </>
                                                    )}
                                                    {particularOrderDetails.loyalty_points_discount !== "0.000000" && (
                                                      <>
                                                        <div className="d-flex justify-content-between ">
                                                          <div className="text-muted">
                                                            Loyalty Points Discount
                                                          </div>
                                                          <div className="text-muted">
                                                            ₹{" "}
                                                            {Number(
                                                              particularOrderDetails.loyalty_points_discount
                                                            ).toFixed(2)}
                                                          </div>
                                                        </div>
                                                      </>
                                                    )}
                                                    {particularOrderDetails.gst_claim === "Y" && (
                                                      <>
                                                        <div className="d-flex justify-content-between ">
                                                          <div className="text-muted">
                                                            CGST
                                                          </div>
                                                          <div className="text-muted">
                                                            ₹{" "}
                                                            {Number(
                                                              particularOrderDetails.tax_cgst
                                                            ).toFixed(2)}
                                                          </div>
                                                        </div>

                                                        <div className="d-flex justify-content-between ">
                                                          <div className="text-muted">
                                                            SGST
                                                          </div>
                                                          <div className="text-muted">
                                                            ₹{" "}
                                                            {Number(
                                                              particularOrderDetails.tax_sgst
                                                            ).toFixed(2)}
                                                          </div>
                                                        </div>
                                                      </>
                                                    )}

                                                    {/* Delivery Fee */}
                                                    <div className="d-flex justify-content-between ">
                                                      <div className="text-muted">
                                                        Delivery Fee
                                                      </div>
                                                      <div className="text-muted">
                                                        + ₹ {particularOrderDetails.delivery_fee}
                                                      </div>
                                                    </div>
                                                    <hr className="m-0 p-0 my-2" />
                                                    {/* Total */}
                                                    <div className="d-flex justify-content-between p-0 m-0">
                                                      <div className="fw-bold text-primary h6 m-0">
                                                        Total Price
                                                      </div>
                                                      <div className="fw-bold text-primary h6 m-0">
                                                        ₹ {particularOrderDetails.totalOrderPrice}
                                                      </div>
                                                    </div>


                                                  </div>
                                                </div>
                                              </div>





                                              <div className="col-4 m-0 p-0 pt-3">
                                                <div
                                                  className="bg-white border-15-only p-4 ms-3 d-flex flex-column justify-content-center align-items-center"
                                                  ref={(el) =>
                                                  (contentRefsCol1.current[
                                                    index
                                                  ] = el)
                                                  }
                                                  style={{
                                                    ...accordionContentStyle,
                                                    height: `${contentRefsCol1.current[index]?.scrollHeight}px`,
                                                    borderRadius: "12px",
                                                    minWidth: "250px",
                                                    maxWidth: "100%",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  {particularOrderDetails.orderType === "dining" ? (
                                                    <>
                                                      <div className="text-muted fs-6 mb-2">
                                                        Dining Order
                                                      </div>
                                                      <div className="fs-4 fw-bold text-dark">
                                                        Table No. {particularOrderDetails.table_no}
                                                      </div>
                                                    </>
                                                  ) : (
                                                    <>
                                                      <div className="text-bold fs-6 mb-2">
                                                        Delivery Address
                                                      </div>
                                                      <div className="fs-6 text-bold text-secondary mb-1">
                                                        {particularOrderDetails.table_no}
                                                      </div>
                                                      <div className="text-5 text-dark fw-semibold">
                                                        {fullAddress &&
                                                          fullAddress
                                                            .trim()
                                                            .replace(/,+/g, "")
                                                            .replace(/\s+/g, "")
                                                            .length > 0 ? (
                                                          <span
                                                            style={{
                                                              whiteSpace:
                                                                "normal",
                                                            }}
                                                          >
                                                            {fullAddress}
                                                          </span>
                                                        ) : (
                                                          <span className="text-danger">
                                                            Address not found
                                                          </span>
                                                        )}
                                                      </div>
                                                    </>
                                                  )}
                                                </div>

                                                {/* Platform Charges Breakdown */}
                                                <div
                                                  style={{
                                                    borderRadius: "12px",
                                                  }}
                                                  className="bg-white mt-3 border-15-only p-4 ms-3 d-flex flex-column justify-content-center align-items-center-4 p-4 bg-light rounded-3  "
                                                >
                                                  <h6 className="text-primary mb-3 fw-bold">
                                                    Platform Charges
                                                  </h6>

                                                  <div className="d-flex justify-content-between">
                                                    <span className="text-muted">
                                                      Messages Sent
                                                    </span>
                                                    <span className="text-muted">
                                                      {particularOrderDetails.message_count || 1}{" "}
                                                      Message(s)
                                                    </span>
                                                  </div>

                                                  <div className="d-flex justify-content-between">
                                                    <span className="text-muted">
                                                      Per Message Cost
                                                    </span>
                                                    <span className="text-muted">
                                                      ₹{" "}
                                                      {Number(
                                                        particularOrderDetails.per_message_cost
                                                      ).toFixed(2)}
                                                    </span>
                                                  </div>

                                                  <div className="d-flex justify-content-between">
                                                    <span className="text-muted">
                                                      Message Charges
                                                    </span>
                                                    <span className="text-muted">
                                                      ₹{" "}
                                                      {(particularOrderDetails.message_count || 1) *
                                                        Number(
                                                          particularOrderDetails.per_message_cost ||
                                                          0
                                                        ).toFixed(2)}
                                                    </span>
                                                  </div>

                                                  <div className="d-flex justify-content-between">
                                                    <span className="text-muted">
                                                      GST on Message Charges
                                                    </span>
                                                    <span className="text-muted">
                                                      ₹{" "}
                                                      {Number(
                                                        particularOrderDetails.message_charges_tax_gst ||
                                                        0
                                                      ).toFixed(2)}
                                                    </span>
                                                  </div>

                                                  <hr className="my-2" />

                                                  <div className="d-flex justify-content-between">
                                                    <strong className="text-dark">
                                                      Total Platform Fee
                                                    </strong>
                                                    <strong className="text-dark">
                                                      ₹{" "}
                                                      {(
                                                        (particularOrderDetails.message_count ||
                                                          1) *
                                                        Number(
                                                          particularOrderDetails.per_message_cost ||
                                                          0
                                                        ) +
                                                        Number(
                                                          particularOrderDetails.message_charges_tax_gst ||
                                                          0
                                                        )
                                                      ).toFixed(2)}
                                                    </strong>
                                                  </div>
                                                </div>
                                              </div>









                                            </div>
                                          </td>
                                        </tr>
                                      </>
                                    )



                                  )}
                                </React.Fragment>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div className="py-3">
                      <Pagination
                        currentPage={currentPage_History}
                        totalPages={totalPages_History}
                        onNextPage={handleNextPage_History}
                        onPrevPage={handlePrevPage_History}
                        onPageClick={handlePageClick_History}
                      />
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div>No orders found.</div>
            )}
          </>
        )}
      </div>
    </div>
  );
};
export default Orders;
const StepperComponent = ({
  status,
  item,
  fullAddress,
  organizationDetails,
  reciptDetails,
  markCompletedForcefullyApi,
  handleKitchenPrint,
}) => {
  const [currentStep, setCurrentStep] = useState(0);
  useEffect(() => {
    if (status === "received") {
      setCurrentStep(0);
    } else if (status?.toLowerCase() === "paid") {
      setCurrentStep(1);
    } else if (status === "dispatched" || status === "not-delivered") {
      setCurrentStep(2);
    } else if (
      status === "completed" ||
      status === "delivered" ||
      status === "ready_for_takeway" ||
      status === "ready_for_dinning"
    ) {
      setCurrentStep(3);
    }
  }, [status]);

  return (
    <div className="col-12 order-stepper-container">
      <div className="order-stepper ms-5" style={{ width: "80%" }}>
        <div className={`order-step ${currentStep >= 0 ? "completed" : ""}`}>
          <div className="order-step-number">1</div>
          <div className="order-step-label">Order Initiated</div>
          <div className="order-step-line"></div>
        </div>
        <div className={`order-step ${currentStep >= 1 ? "completed" : ""}`}>
          <div className="order-step-number">2</div>
          <div className="order-step-label">Order Payment</div>
          <div className="order-step-line"></div>
        </div>
        <div className={`order-step ${currentStep >= 2 ? "completed" : ""}`}>
          <div className="order-step-number">3</div>
          <div className="order-step-label">Order Dispatched</div>
          <div className="order-step-line"></div>
        </div>
        <div className={`order-step ${currentStep === 3 ? "completed" : ""}`}>
          <div className="order-step-number">4</div>
          <div className="order-step-label">Order Completed</div>
        </div>

        {currentStep > 2 && (
          <div>
            <button
              className="download-receipt"
              onClick={() =>
                downloadReceipt(
                  item,
                  fullAddress,
                  organizationDetails,
                  reciptDetails
                )
              }
            >
              Download Receipt
            </button>
          </div>
        )}
        {currentStep === 2 && (
          <div>
            <button
              className=" btn bg-danger text-white outline-danger"
              onClick={() => markCompletedForcefullyApi(item.orderid)}
            >
              Mark as Delivered
            </button>
          </div>
        )}
        {currentStep < 2 && (
          <div className="p-1">
            <button
              className="download-receipt"
              onClick={() =>
                handleKitchenPrint(reciptDetails, item, fullAddress)
              }
            >
              Kitchen Receipt
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const downloadReceipt = (
  item,
  fullAddress,
  organizationDetails,
  reciptDetails
) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = generateReceiptTharmalPrinter(
    item,
    fullAddress,
    organizationDetails,
    reciptDetails
  );
  tempDiv.style.width = "288px";
  document.body.appendChild(tempDiv);
  html2canvas(tempDiv, {
    width: 288,
    scale: 3,
  }).then((canvas) => {
    const link = document.createElement("a");
    link.href = canvas.toDataURL("image/png");
    link.download = `receipt_${item.orderid}.png`;
    link.click();
    document.body.removeChild(tempDiv);
  });
};
const generatePNG = async (
  item,
  fullAddress,
  organizationDetails,
  reciptDetails
) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = generateReceiptHTML(
    item,
    fullAddress,
    organizationDetails,
    reciptDetails
  );
  tempDiv.style.width = "600px";
  tempDiv.style.position = "absolute"; // Position it off-screen
  tempDiv.style.left = "-9999px"; // Prevent it from affecting the layout
  document.body.appendChild(tempDiv);
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      html2canvas(tempDiv, {
        width: 600, // Set width to match the div
        scale: 2, // Maintain the same scale
      })
        .then((canvas) => {
          // Convert the canvas to Base64 PNG image
          const pngBase64 = canvas.toDataURL("image/png").split(",")[1]; // Extract Base64 part
          // Clean up the temporary div
          document.body.removeChild(tempDiv);
          resolve(pngBase64);
        })
        .catch((error) => {
          // Clean up on error
          document.body.removeChild(tempDiv);
          reject(error);
        });
    }, 50); // Adjust this delay as needed (50ms is usually enough)
  });
};

const generateReceiptTharmalPrinter = (
  item,
  fullAddress,
  organizationDetails,
  reciptDetails
) => {
  return `
    <html>
    <head>
      <style>
        body { font-family: Arial, sans-serif;  }
        .container { max-width:600px;  }
         .header {
    display: flex;
    flex-direction: column;
    justify-content: center; 
    align-items: center;         
    text-align: center;            
    color: #000;
    line-height: 1.1;
    border-bottom: 1px dashed #000;
    margin-top: 10px;
  }

  .header2 {
    display: flex;
    flex-direction: column;
    justify-content: flex-start; 
    align-items: flex-start;         
    text-align: start;            
    color: #000;
    line-height: 1.5;
    border-bottom: 1px dashed #000;
       margin-top: 5px;
       padding-bottom: 5px;
  }
   .headerTable {
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-start; 
                        align-items: flex-start;         
                        text-align: start;            
                        color: #000;
                        line-height: 1.1;
                        border-bottom: 1px dashed #000;
                        padding: 0;
                        margin: 0;
                    }
    .headerTotal {
    display: flex;
    flex-direction: column;
    justify-content: flex-start; 
    align-items: flex-start;         
    text-align: start;            
    color: #000;
    line-height: 1.1;
    border-bottom: 1px dashed #000;
      
  }
 .headerEnd {
    text-align: center;            
    color: #000; 
     padding-bottom: 5px;
  }
.textSizeLarge {
  font-size: 16px;
  margin: 1px; /* Remove margin */
  padding: 1px; /* Remove padding */
}
.textSizeMid {
  font-size: 10px;
  margin: 1px; /* Remove margin */
  padding: 1px; /* Remove padding */
}
.textSizeSmall {
  font-size: 9px;
  margin: 1px; /* Remove margin */
  padding: 1px; /* Remove padding */
}
.textWhite{
color:#fff !importent;
}
       .order-details { width: 100%; border-collapse: collapse; }
                    .order-details th,
                    .order-details td { padding: 5px; font-size: 10px; text-align: left; }
        .order-details2 th, 
        .order-details2 td { padding:5px; font-size: 10px; text-align: left;}
        .total-row { font-weight: bold; }
       
        .table-text-center{ text-align: center; }
      </style>
    </head>
    <body>
      <div class="container">
       <div class="header">
  <p class="textSizeLarge" style=" font-weight: 600;">${reciptDetails.business_name
    }</p>
  <p class="textSizeMid" > ${reciptDetails.address}</p>
  <p class="textSizeMid" >PH: ${reciptDetails.phone_no}</p>
  <p class="textSizeMid" >GST NO: ${reciptDetails.gst}</p>  
  <p class="textSizeLarge" style=" font-weight: 600;">** INVOICE **</p>
</div>
<div class="header2">
  <p class="textSizeMid" >Bill No: ${reciptDetails.bill_no}</p>
  <p class="textSizeMid" >Order No: ${item.daily_order_id}</p>
   <p class="textSizeMid" >Customer Name: ${item.customer_name}</p>
      <p class="textSizeMid" >Customer Mobile: ${item.customer_mobile}</p>
  <p class="textSizeMid" >Payment Status: ${item.payment_status}</p>  
  <p class="textSizeMid" >Printed: ${item.order_date}</p>  
  <p class="textSizeMid">
    Delivery Partner Name: ${item.delivery_person_name ? item.delivery_person_name : "Not assigned"
    }
</p>
<p class="textSizeMid">
    Delivery Partner Mobile No.: ${item.delivery_person_number ? item.delivery_person_number : "Not assigned"
    }
</p>
   <p class="textSizeMid" >Delivery Address: ${fullAddress}</p> 
</div>
  <div class="headerTable">
                        <table class="order-details" style="width: 100%; border-collapse: collapse;">
                            <thead>
                                <tr>
                                    <th class="table-text-center"></th>
                                    <th class="table-text-center">ITEM</th>
                                    <th class="table-text-center">QTY</th>
                                    <th class="table-text-center">PRICE</th>
                                    <th class="table-text-center">TOTAL</th>
                                </tr>
                            </thead>
                            <tbody>
                                ${item.items
      .map(
        (subitem, index) => `
                                    <tr>
                                        <td class="table-text-center">${1 + index
          }</td>
                                        <td class="table-text-center">${subitem.product_id
          }</td>
                                        <td class="table-text-center">${subitem.quantity
          }</td>
                                        <td class="table-text-center">${subitem.item_price
          }</td>
                                        <td class="table-text-center">${subitem.total_price
          }</td>
                                    </tr>
                                `
      )
      .join("")}
                            </tbody>
                        </table>
                    </div>
      <div class="headerTotal">
                       <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; ">
                            <p class="textSizeMid" style="margin: 2px;">Sub Total :</p>
                            <p class="textSizeMid" style="margin: 2px;">Rs. ${item.subtotal
    }</p>
                        </div>

                           <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; ">
                            <p class="textSizeMid" style="margin: 2px;">Delivery Fee :</p>
                            <p class="textSizeMid" style="margin: 2px;">Rs. ${item.delivery_fee
    }</p>
                        </div>

                           <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; ">
                            <p class="textSizeMid" style="margin: 2px;">Other Fee :</p>
                            <p class="textSizeMid" style="margin: 2px;">Rs. ${item.other_fee
    }</p>
                        </div>
                          <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; ">
                            <p class="textSizeMid" style="margin: 2px;">Discount Percentage :</p>
                            <p class="textSizeMid" style="margin: 2px;">${item.discount_percentage
    }%</p>
                        </div>
                          <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; ">
                            <p class="textSizeMid" style="margin: 2px;">Discount Amount :</p>
                            <p class="textSizeMid" style="margin: 2px;">Rs. ${item.discount_amount
    }</p>
                        </div>
                           <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; font-weight: 600;">
                            <p class="textSizeMid" style="margin: 2px;">Total Amount :</p>
                            <p class="textSizeMid" style="margin: 2px;">Rs. ${item.totalOrderPrice
    }</p>
                        </div>


                    </div>
             <div class="header2">
            <p class="textSizeMid" >Net Amount : Rs. ${item.totalOrderPrice}</p>
               <p class="textSizeMid" >Paid Amount : Rs. ${item.totalOrderPrice
    }</p>
               
          </div>
  <div class="headerEnd">
            <p class="textSizeMid" >Thank you for your purchase!</p>
             <p class="textSizeSmall" >* ${reciptDetails.tag_line1} *</p>
          </div>
        </div>
      </div>
    </body>
    </html>
  `;
};
const generateReceiptHTML = (
  item,
  fullAddress,
  organizationDetails,
  reciptDetails
) => {
  // const logoBase64 =
  //   "data:image/png;base64,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"; // Replace with actual Base64 string
  const successTickBase64 =
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAA0CAYAAAA3xE5OAAAACXBIWXMAAAWJAAAFiQFtaJ36AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHdSURBVHgB7ZvNUcMwEEZX0IA7gA5CB6GD0IE5cksJKQE6cAlABSkhdCCoAI7cPtYj+5JRiC2tFOvnzez4ZGv3eayRvbKiAgFwy4eW446j4fjgeFFKfVGpsJQdTvNMJXJGSply+oIxnfU1FQAX2vHhacYpP9mLGaQ80jx+ryhjHKXkCwtpOF7hzpZyY5BygDua44ZyQkBKz4ZyQkhKSznBBd1WKUcMUjTc+eZYUU5UKRaqFAtVigUBKRoZrlOqlGOqFAtc0ApmXqhSRqoUC1WKBS5oXaUcwQW18OMgLqW/IMcG5o5FNy4kpSEpYJ7nvWWgLpagJUrZnBlQI/ASmq+/hR/iUqYunIK9X2BaI+w/9qJShqTaGQmIyxGQ0lEIYJ9XoshZrJQhuT3c8PoUuGgpQ4JzeroicgSkhG+8w6xXfJglR0DKjmIBs1bxYVLnLikpQ8KNgJzdmTE6+BFXSozkkbKUUEUgBykjEsUgwuN5EeA/UWr4sTwpIwJyXFn+/pQLyEmnuR5RTno7DiLISXcbRiA5/dv6PaWOsJy8mutCcvLbcdADvw/XeUoZcZSjkVsjzMZMOboIKSMT5ZQlZQSmYadPSJFvmQZGkSAwv9StOR7I/FL3yfGmlHqnxPgDeOsIi8wLnOkAAAAASUVORK5CYII="; // Replace with actual Base64 string
  return `
    <html>
    
    <head>
      <style>
        body { font-family: Arial, sans-serif;  }
        .container { max-width:600px;  }
  .receipt-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top:15px;
}

.left-side {
  
  text-align: left;
}

.right-side {

  text-align: right;
}

.business-name{
  margin: 0;
  padding: 0;
  color:#000;
  font-size:16px;
}

.address{
  margin: 0;
  padding: 0;
  color:#000;
    font-size:10px;
}

.phone-number{
  margin: 0;
  padding: 0;
  color:#000;
    font-size:10px;
} 

.gst-number {
  margin: 0;
  padding: 0;
  color:#000;
    font-size:10px;
}
.single-line-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}    .headerTotal {
    display: flex;
    flex-direction: column;
    justify-content: flex-start; 
    align-items: flex-start;         
    text-align: start;            
    color: #000;
    line-height: 1.1;
 
      
  }
       .header {
  display: flex;
  justify-content: space-between; 
  align-items: center;          
  text-align: center;            /* Center text inside */
  margin-top: 10px;                /* Center the .header container itself */
  padding: 0 10px;               /* Optional: Add padding to the container */
}
        .header img { max-width: 80px; }
        .header-date { text-align: right; font-size: 12px; }
        .order-confirmation { text-align: center; padding: 20px 0; margin-bottom: 20px; }
        .order-confirmation img { width: 100px; height: auto; margin-bottom: 10px; }
        .order-confirmation h2 { margin: 0 0 10px; color: #333; font-size: 24px; }
        .order-confirmation p { margin: 0; color: #555; font-size: 14px; }
        .order-details { width: 100%; border-collapse: collapse; }
        .order-details th, .order-details td { padding: 10px;font-size: 14px; text-align: left;}
        .order-details th {color: #333; font-weight: bold; }
        .total-row { font-weight: bold; }
        .footer { margin:10px ; font-size: 14px; color: #000; }
        .table-text-center{ text-align: center; }
.customer-order-details {
  width: 100%;
  border-collapse: collapse; /* Ensures no space between table cells */
}

.customer-order-details th, 
.customer-order-details td {
  padding: 5px 5px; /* Increased vertical padding (top and bottom) */
  font-size: 12px;
  text-align: left;
}
.customer-order-details th {
  color: #333;
  font-weight: bold;
}
.customer-total-row {
  font-weight: bold;
}
.customer-footer {
  margin: 10px;
  font-size: 14px;
  color: #000;
}
  .force-black-text {
    color: #000 !important; 
  }
.customer-table-text-center {
  text-align: center;
}
      </style>
    </head>
    <body>
      <div class="container">
           <div class="receipt-header">
  <div class="left-side">
    <p class="business-name">${reciptDetails.business_name}</p>
    <p class="address">${reciptDetails.address}</p>
  </div>
  <div class="right-side">
    <p class="phone-number">Phone No. ${reciptDetails.phone_no}</p>
    <p class="gst-number">GST No. ${reciptDetails.gst}</p>
  </div>
        </div>
        <div class="order-confirmation">
          <div style="
          display: inline-block;
          width: 80px;
          height: 80px;
          background-color: #01C37D;
          border-radius: 50%;
          padding: 20px;
          margin-bottom:10px;
        ">
          <img src="${successTickBase64}" alt="Order Confirmed" style="
            width: 100%;
            height: 100%;
            object-fit: contain;
          " />
        </div>
          <h2>Order Dispatched!</h2>
          <p>We are pleased to confirm that your order has been successfully processed and is now dispatched.</p>
        </div>
        <div style=" margin:10px ; padding:10px; background-color: #F9F9F9; text-align: center; border-radius:10px">
        <table class="customer-order-details">
          <tr>
            <th class="single-line-text">Order Id</th>
            <td>${item.daily_order_id}/${item.orderid}</td>
          </tr>
           <tr>
            <th class="single-line-text">Name</th>
            <td>${item.customer_name}</td>
          </tr>
           <tr>
            <th class="single-line-text">Contact Number</th>
            <td>${item.customer_mobile}</td>
          </tr>
           <tr>
            <th class="single-line-text">Order Date</th>
            <td>${item.order_date}</td>
          </tr>
             <tr>
              <tr>
            <th class="single-line-text">Order Type</th>
            <td>${item.orderType}</td>
          </tr>
             <tr>
            <th class="single-line-text">Payment Status</th>
            <td>${item.payment_status}</td>
          </tr>
          
         
          <tr>
            <th class="single-line-text">Delivery Address</th>
            <td>${fullAddress}</td>
          </tr>
        </table>
        <hr style=" color: #000;" />
      <table class="order-details" >
          <thead>
             <tr >
              <th class="table-text-center force-black-text">S.No.</th>
              <th class="table-text-center force-black-text">Item Name</th>
              <th class="table-text-center force-black-text"> Quantity</th>
              <th class="table-text-center force-black-text">Unit Price</th>
              <th class="table-text-center force-black-text">Sub Total</th>
            </tr>
          </thead>
          <tbody>
            ${item.items
      .map(
        (subitem, index) => `
                <tr>
                <td class="table-text-center force-black-text" >${1 + index
          }</td>
                  <td class="table-text-center force-black-text" >${subitem.product_id
          }</td>
                  <td class="table-text-center force-black-text" style:"text-align: center">${subitem.quantity
          }</td>
                  <td class="table-text-center force-black-text">${subitem.item_price
          }</td>
                  <td class="table-text-center force-black-text">${subitem.total_price
          }</td>
                </tr>
              `
      )
      .join("")}
          </tbody>
        
        </table>
          <hr style=" color: #000;" />
          
          
      <div class="headerTotal">
    <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
      <p class="textSizeMid" style="margin: 5px;">Sub Total  ${item.gst_claim !== "Y" ? <span>(Tax Inc.)</span> : ""
    } :</p>
      <p class="textSizeMid" style="margin: 5px;">Rs. ${item.subtotal}</p>
    </div>

    ${item.coupon_applied
      ? `
      <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
        <p class="textSizeMid" style="margin: 5px;">Coupon Discount :</p>
        <p class="textSizeMid" style="margin: 5px;">Rs. ${Number(
        item.coupon_code_discount
      ).toFixed(2)}</p>
      </div>
    `
      : ""
    }

 ${item.loyalty_points_discount !== "0.000000"
      ? `
      <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
        <p class="textSizeMid" style="margin: 5px;">Loyalty Points Discount :</p>
        <p class="textSizeMid" style="margin: 5px;">Rs. ${item.loyalty_points_discount}</p>
      </div>
    `
      : ""
    }
    ${item.discount_amount !== "0.00"
      ? `
      <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
        <p class="textSizeMid" style="margin: 5px;">Discount Amount (${item.discount_percentage}) :</p>
        <p class="textSizeMid" style="margin: 5px;">Rs. ${item.discount_amount}</p>
      </div>
    `
      : ""
    }

    ${item.gst_claim === "Y"
      ? `
      <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
        <p class="textSizeMid" style="margin: 5px;">CGST :</p>
        <p class="textSizeMid" style="margin: 5px;">Rs. ${Number(
        item.tax_cgst
      ).toFixed(2)}</p>
      </div>
      <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
        <p class="textSizeMid" style="margin: 5px;">SGST :</p>
        <p class="textSizeMid" style="margin: 5px;">Rs. ${Number(
        item.tax_sgst
      ).toFixed(2)}</p>
      </div>
    `
      : ""
    }

    <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
      <p class="textSizeMid" style="margin: 5px;">Delivery Fee :</p>
      <p class="textSizeMid" style="margin: 5px;">Rs. ${item.delivery_fee}</p>
    </div>

    <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
      <p class="textSizeMid" style="margin: 5px;">Other Fee :</p>
      <p class="textSizeMid" style="margin: 5px;">Rs. ${item.other_fee}</p>
    </div>

    <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; font-weight: 600;">
      <p class="textSizeMid" style="margin: 5px;">Total Amount :</p>
      <p class="textSizeMid" style="margin: 5px;">Rs. ${item.totalOrderPrice
    }</p>
    </div>
  </div>
     
        <div class="footer">
          <div style="text-align: center;">
        <p style="font-size:"12px">Thank you for your purchase!</p>
         <p style="font-size:"10px">* ${reciptDetails.tag_line1} *</p>
      </div>
        </div>
      </div>
    </body>
    </html>
  `;
};
